import { Box, Button as MuiButton, Dialog, FormControlLabel, Grid, IconButton, Link, Stack, Switch, switchClasses, Typography, useMediaQuery, useTheme, } from "@mui/material";
import Header from "../../common/Header";
import Card from "../../common/Card";
import Button from "../../common/Button";
import {
  AddCircleOutlineOutlined, ArrowBackOutlined, AssignmentOutlined, AttachMoneyOutlined, Cancel, CancelOutlined, DeleteOutlineOutlined, DescriptionOutlined,
  DoDisturbAltOutlined, Download, FiberManualRecord, HubOutlined, InfoOutlined, Inventory2Outlined, LocalShippingOutlined,
  ModeOutlined, MonetizationOnOutlined, Restore, SaveOutlined, ShoppingCartOutlined, TuneOutlined, Upgrade,
  UploadFileOutlined,
} from "@mui/icons-material";
import { useModalStyles } from "../../common/useModalStyles";
import { ChangeEvent, useCallback, useEffect, useMemo, useRef, useState } from "react";
import ProductItemPopup from "./ProductItemPopup";
import ProductItemPricePricePopup from "./ProductItemPricePopup";
import ProductItemsPricePopup from "./ProductItemsPricePopup";
import {
  DocumentItemInfo, ProductInfo, ProductItemInfo, ProductItemPriceInfo, ProductItemsPriceInfo,   createProduct, deleteProductPriceObj, fetchProductDocumentsByProductId, getProduct, getProductPricingHistory,
  inactivateProductPrice, inactiveProductDocument, initialValuesOfProductItem, initialValuesOfProductItemPrice, initialValuesOfProductItemsPrice, resetCreateProductSlice,
  resetFetchStatus, saveAllProductItemsPrices, saveProductItem, saveProductLogo, saveProductPriceItem, updateElementInProductSlice, updateProductDetails, useProductReducer,
  ProductPurchasePriceInfo, ProductDocumentListInfo,
} from "../../../redux/slice/product/createProductSlice";
import { Controller, useForm } from "react-hook-form";
import CustomTextField from "../../common/CustomTextField";
import moment from "moment";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import { updateProductTierPrices } from "../../../service/ProductService";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import CustomTable from "../../common/CustomTable";
import { CodeTable, getCodeTableValuesByTableName, useCodetablesSlice } from "../../../redux/slice/codetableSlice";
import { calculateValue, mapCategoryLabel } from "../../../utils/Utility";
import { getExploreMarketProductActionFlags } from "../../../utils/exploreMarketProductActions";
import { fetchMac, fetchManufacturersList, useCommonReducer, setSingleAlertObj, SingleAlertInfo, hideSingleAlert } from "../../../redux/slice/commonSlice";
import { PRODUCTS_DOCUMENT_TYPE, PRODUCT_DOCUMENT_STATUS, PRODUCT_DOCUMENT_TYPES, PRODUCT_SHIPPING_ACTIONS, png, USER_ROLES, PRODUCT_CATEGORY_CODETABLE, PRODUCT_CATEGORY, PATIENT_LIST_ACTIONS, PRODUCT_CONFIG_TYPE, PRODUCT_CONFIG_CODE, PRODUCT_CONFIG_VALUE, TIER_PRICE_CODETABLE } from "../../../constants/applicationConstants";
import { FileUploader } from "../../common/FileUploader";
import ProductItemHistoryPopup from "./ProductItemHistoryPopup";
import ProductItemPriceHistoryPopup from "./ProductItemPriceHistoryPopup";
import OptionsPopup, { OptionPopupObjectProps } from "../../common/OptionsPopup";
import CustomCurrencyField from "../../common/CustomCurrencyField";
import DatePickerPopup from "../../common/DatePickerPopup";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { selectIsTokenAvailable, selectIsValueFoundInToken, useAuthSlice } from "../../../redux/slice/authSlice";
import { fetchDocumentById, fetchTemplateById } from "../../../redux/slice/practiceSlice";
import CloseIcon from "@mui/icons-material/Close";
import { tokens } from "../../../theme";
import CustomIconButton from "../../common/CustomIconButton";
import dayjs from "dayjs";
import CustomSwitchButton from "../../common/CustomSwitchButton";
import ProductDocumentPopup from "./ProductDocumentPopup";
import CustomCommentPreview from "../../common/CustomCommentPreview";
import CustomTooltip from "../../common/CustomTooltip";
import ProductDocumentHistory from "./ProductDocumentHistory";
import UpdateProductDocumentStatusPopup from "./UpdateProductDocumentStatusPopup";
import ProductAgreementPopup from "./ProductAgreementPopup";
import ProductConfigPopup from "./ProductConfigPopup"; // CS-1760
import { styled } from '@mui/material/styles';
import AddProductKitPopup from "./AddProductKitPopup";
import { initialValuesOfProductkitItem, ProductkitItemInfo } from "../../../redux/slice/product/createProductSlice";
import ProductItemSKULevelPriceHistoryPopup from "./ProductItemSKULevelPriceHistoryPopup";
import { useNavigation } from "../../../hooks/useNavigation";
// CS-1766 - Product Shipping Configuration
import ProductShippingConfig from "./ProductShippingConfig";
import ProductCogsSection from "./ProductCogsSection";
import ProductTabNav, { ProductTabItem } from "./ProductTabNav";
import { ProductConfigRules, getProductConfigByProduct } from "../../../service/ProductService";
import OrderProductModal from "../account/OrderProductModal";
import CompletePracticeRegistrationModal from "../account/CompletePracticeRegistrationModal";
import PrescriptionModalPopup from "../prescription/PrescriptionModalPopup";
import InfoPopup from "../../common/InfoPopup";
import WarningPopupNew, { WarningPopupNewObjectProps } from "../../common/WarningPopupNew";
import { getExploreMarketProducts, MarketProduct } from "../../../redux/slice/exploreMarket/exploreMarketSlice";
import { submitPrescription } from "../../../redux/slice/prescription/prescriptionSlice";

type ProductTabId = "info" | "config" | "catalog" | "pricing" | "cogs" | "shipping" | "document";




type Column = {
  id: string;
  label: string;
  minWidth?: number;
  width?: number;
  align?: "right" | "center" | "left";
  format?: (value: number) => string;
}



export const SwitchTextTrack = styled(Switch)({
  width: 80,
  height: 48,
  padding: 8,
  [`& .${switchClasses.switchBase}`]: {
    padding: 11,
    color: "#ff6a00",
  },
  [`& .${switchClasses.thumb}`]: {
    width: 26,
    height: 26,
    backgroundColor: "#fff",
  },
  [`& .${switchClasses.track}`]: {
    background: "linear-gradient(to right,rgb(161, 161, 161),rgb(84, 84, 84))",
    opacity: "1 !important",
    borderRadius: 20,
    position: "relative",
    "&:before, &:after": {
      display: "inline-block",
      position: "absolute",
      top: "50%",
      width: "50%",
      transform: "translateY(-50%)",
      color: "#fff",
      textAlign: "center",
      fontSize: "0.75rem",
      fontWeight: 500,
    },
    "&:before": {
      content: '"ON"',
      left: 4,
      opacity: 0,
    },
    "&:after": {
      content: '"OFF"',
      right: 4,
    },
  },
  [`& .${switchClasses.checked}`]: {
    [`&.${switchClasses.switchBase}`]: {
      color: "#185a9d",
      transform: "translateX(32px)",
      "&:hover": {
        backgroundColor: "rgba(24,90,257,0.08)",
      },
    },
    [`& .${switchClasses.thumb}`]: {
      backgroundColor: "#fff",
    },
    [`& + .${switchClasses.track}`]: {
      background: "linear-gradient(to right,rgb(0, 196, 88),rgb(0, 97, 29))",
      "&:before": {
        opacity: 1,
      },
      "&:after": {
        opacity: 0,
      },
    },
  },
});

const HAS_SKU_PRICE_LOCKED_MESSAGE = "Cannot edit because already has product pricing";

const hasPersistedPriceValue = (value: unknown): boolean =>
  value !== null && value !== undefined && value !== "";

const productHasExistingPricing = (
  productPrices: any,
  productItems: any[] | undefined,
  productPriceRows?: any[]
): boolean => {
  if (Array.isArray(productPrices) && productPrices.length > 0) return true;
  if (productPrices && typeof productPrices === "object" && !Array.isArray(productPrices)) {
    if (productPrices.newProductPrice) return true;
    if (Array.isArray(productPrices.ProductItemPrices) && productPrices.ProductItemPrices.length > 0) {
      return true;
    }
  }
  if (Array.isArray(productPriceRows) && productPriceRows.length > 0) return true;
  return (productItems || []).some((item) =>
    Boolean(item?.productItemPriceId) ||
    hasPersistedPriceValue(item?.listPrice) ||
    hasPersistedPriceValue(item?.allowableUnitPrice) ||
    hasPersistedPriceValue(item?.customPrice)
  );
};

const Product = () => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const colors = tokens(theme.palette.mode);
  const isDark = theme.palette.mode === "dark";
  const { userInfo } = useAuthSlice();

  const dispatch = useAppDispatch();
  const { navigate } = useNavigation();

  const [productItemObject, setProductItemObject] = useState<ProductItemInfo>(initialValuesOfProductItem);
  const [productItemkitObject, setProductItemkitObject] = useState<ProductkitItemInfo>(initialValuesOfProductkitItem);
  const [priceItemObject, setPriceItemObject] = useState<ProductItemPriceInfo>(initialValuesOfProductItemPrice);
  const [priceItemsObject, setPriceItemsObject] = useState<ProductItemsPriceInfo>(initialValuesOfProductItemsPrice);
  const [tableRowIndex, setTableRowIndex] = useState<number | null>(null);
  const [editForm, setEditForm] = useState(false);
  const [editItem, setEditItem] = useState(false);
  const [inactiveOnly, setInactiveOnly] = useState(false);
  const [isProductDocumentPopupOpen, setProductDocumentPopupOpen] = useState(false);

  const [showProductItemPopup, setShowProductItemPopup] = useState(false);
  const [showProductItemKitPopup, setShowProductItemkitPopup] = useState(false);
  const [showProductItemPricePopup, setShowProductItemPricePopup] = useState(false);
  const [showProductItemsPricePopup, setShowProductItemsPricePopup] = useState(false);

  const [showProductItemHistoryPopup, setShowProductItemHistoryPopup] = useState(false);
  const [showProductItemSKULevelHistoryPopup, setShowProductItemSKULevelHistoryPopup] = useState(false);
  const [showProductItemPriceHistoryPopup, setShowProductItemPriceHistoryPopup] = useState(false);
  const [showProductAgreementPopup, setShowProductAgreementPopup] = useState(false);
  // CS-1760 START
  const [activeTab, setActiveTab] = useState<ProductTabId>("info");
  const [draftProductConfigRules, setDraftProductConfigRules] = useState<ProductConfigRules[]>([]);
  const [draftProductPurchasePrices, setDraftProductPurchasePrices] = useState<ProductPurchasePriceInfo[]>([]);
  // Local copy of config rules after Product Config save so COGs visibility updates without refetch/remount.
  const [savedProductConfigRules, setSavedProductConfigRules] = useState<ProductConfigRules[] | null>(null);
  const [fetchedProductConfigRules, setFetchedProductConfigRules] = useState<ProductConfigRules[]>([]);
  // CS-1760 END

  const [productPriceRows, setProductPriceRows] = useState<any[]>([]);

  const [productItemRows, setProductItemRows] = useState<any[]>([]);

  const [optionPopupShow, setOptionPopupShow] = useState<OptionPopupObjectProps>({ message: "", show: false });

  const [datePickerPopupObj, setDatePickerPopupObj] = useState
                                                  <{label: string, title: string, open: boolean, validationArray: any, submitDate: (date: string)=> void}>
                                                  ({label: "", title: "", open: false, validationArray: [], submitDate: (date: string)=> {}});

  const [showProductDocumentHistoryPopup, setProductDocumentHistoryPopup] = useState(false);
  const [showDocInactivePopup, setShowDocInactivePopup] = useState<{
    isShow: boolean;
    productId: number;
    manufacturerId: number | null;
    documentId: number | string;
  }>({ isShow: false, productId: 0, manufacturerId: null, documentId: 0 });

  const { control, handleSubmit, getValues, setValue, watch, reset, formState: { errors } } = useForm<ProductInfo>();
  const {
    tokens: modalTokens,
    iconBoxSx,
    dropdownWrapSx,
    inputFieldSx,
    primaryBtnSx,
    cancelBtnSx,
    paperSx,
    headerSx,
    bodySx,
    footerSx,
    closeIconSx,
    scrollAreaSx,
  } = useModalStyles();

  const { productObject, getProductStatus, saveProductItemStatus, saveProductPriceStatus,
    updateProductStatus, saveProductLogoStatus, productDocumentInfo, createProductStatus, 
    inactivateProductDocumentStatus } = useProductReducer();
  const { allCodeTablesValuesMap, allCodeTableValueFetchStatus } = useCodetablesSlice();
  const { macInfoList, manufacturerInfoList } = useCommonReducer();

  const [productCategories, setProductCategories] = useState<CodeTable[]>([]);

  const isDownloading = useRef(false);

  // validate user level authorizations
  const canEditProduct = useSelector((state: RootState) => selectIsTokenAvailable("canEditProduct")(state));
  const canEditProductConfig = useSelector((state: RootState) => selectIsTokenAvailable("canEditProductConfig")(state));
  const canManageTierPrice = useSelector((state: RootState) => selectIsTokenAvailable("canManageTierPrice")(state));
  const [tierPriceTarget, setTierPriceTarget] = useState<{ productPriceId?: number; } | null>(null);
  const [viewTierRows, setViewTierRows] = useState<{ tier: string; price: string }[]>([]);
  const [showViewTierEditor, setShowViewTierEditor] = useState(false);
  const [editingViewTier, setEditingViewTier] = useState<string | null>(null);
  const [tierDeletePopup, setTierDeletePopup] = useState<OptionPopupObjectProps>({ message: "", show: false });
  const viewTierForm = useForm<{ tier: string; price: string }>({ defaultValues: { tier: "", price: "" } });
  const canViewProductHistory = useSelector((state: RootState) => selectIsTokenAvailable("canViewProductHistory")(state));
  const canChangeProductDocumentStatus = useSelector((state: RootState) => selectIsTokenAvailable("canChangeProductDocumentStatus")(state));
  const canInactivateProductDocument = useSelector((state: RootState) => selectIsTokenAvailable("canInactivateProductDocument")(state));
  const canViewProductTemplateSection = useSelector((state: RootState) => selectIsTokenAvailable("canViewProductTemplateSection")(state));
  const canAccessHasSKUToggleButton = useSelector((state: RootState) => selectIsTokenAvailable("canAccessHasSKUToggleButton")(state));
  // CS-1766 - Token-based access control for Product Shipping section (VIEW/EDIT)
  const canViewProductShipping = useSelector((state: RootState) => selectIsValueFoundInToken("canMaintainShippingDetails", PRODUCT_SHIPPING_ACTIONS.VIEW)(state));
  const canEditProductShipping = useSelector((state: RootState) => selectIsValueFoundInToken("canMaintainShippingDetails", PRODUCT_SHIPPING_ACTIONS.EDIT)(state));
  const canCreateOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.CREATE_ORDER)(state));
  const canPracticeSignAgreement = useSelector((state: RootState) => selectIsTokenAvailable("canPracticeSignAgreement")(state));
  const isSuperAdmin = userInfo?.userRole === USER_ROLES.ROLE_SUPERADMIN;
  const isRestrictedUser = userInfo?.userRole === USER_ROLES.ROLE_PRACTICE_USER_PRU;
  const canRequestAgreement = canPracticeSignAgreement || isRestrictedUser;
  const marketData = useSelector((state: RootState) => state.exploreMarket?.marketData || []);
  const isPurchaseAndBillEnabled = useMemo(() => {
    const configRules = editForm
      ? (savedProductConfigRules ?? productObject?.configRules)
      : draftProductConfigRules;
    const purchaseAndBillRule = configRules?.find(
      (rule: ProductConfigRules) =>
        rule.configType === "PURCHASE_AND_BILL" &&
        rule.configCode === "ENABLE"
    );
    if (purchaseAndBillRule) {
      return purchaseAndBillRule.value === "Y";
    }
    return productObject?.purchaseAndBill === "Y";
  }, [savedProductConfigRules, productObject?.purchaseAndBill, productObject?.configRules, draftProductConfigRules, editForm]);
  const [isEditing, setIsEditing] = useState(false);
  const [statusData, setStatusData] = useState<any>({
    productId: "",
    documentId: "",
    manufacturerId: null,
    status: "",
    documentType: ""
  });
  const [showUpdateStatusPopup, setUpdateStatusPopup] = useState(false);
  const [originalStatusValue, setOriginalStatusValue] = useState<any>();
  const [productManufacturerId, setProductManufacturerId] = useState<number | null>(null);
  const [productDocumentType, setProductDocumentType] = useState<string>("");
  const [productDocumentName, setProductDocumentName] = useState<string>("");
  const [productDocumentTypeMap, setProductDocumentTypeMap] = useState<Record<string, string>>({});
  const [rowData, setRowData] = useState(null);
  const [selectedProductCategory, setSelectedProductCategory] = useState<string>("");
  const [selectedProductManufacture, setSelectedProductManufacture] = useState<number| null>(null);
  const [orderOpen, setOrderOpen] = useState(false);
  const [isOpenPrescription, setIsOpenPrescription] = useState(false);
  const [showInfoPopup, setShowInfoPopup] = useState<{ message: string; show: boolean; title: string }>({ message: "", show: false, title: "" });
  const [showPRUWarning, setShowPRUWarning] = useState<WarningPopupNewObjectProps>({ show: false, message: "" });
  const [registrationModalOpen, setRegistrationModalOpen] = useState(false);
  const [actionMarketProduct, setActionMarketProduct] = useState<MarketProduct | null | undefined>(undefined);
  const [productConfigLoaded, setProductConfigLoaded] = useState(false);
  const selectedManufacturerId = watch('manufacturerId');
  const watchedProductCategory = watch("productCategory") || "";
  const watchedHasSKUPrice = watch("hasSKUPrice");
  const watchedProductItems = watch("productItems");
  const watchedProductPrices = watch("productPrices");
  const watchedProductName = watch("productName");
  const safeProductName = typeof watchedProductName === "string" ? watchedProductName.trim() : "";
  const hasExistingProductPricing = useMemo(
    () => productHasExistingPricing(
      watchedProductPrices ?? productObject?.productPrices,
      watchedProductItems ?? productObject?.productItems,
      productPriceRows
    ),
    [productObject?.productItems, productObject?.productPrices, productPriceRows, watchedProductItems, watchedProductPrices]
  );
  const isHasSKUPriceLockedByPricing = Boolean(editForm && hasExistingProductPricing);
  const isHasSKUPriceDisabled = !(canEditProduct || !editForm) || isHasSKUPriceLockedByPricing;

  const productTabs = useMemo<ProductTabItem[]>(() => {
    const lockOtherTabs = !editForm;
    const tabs: ProductTabItem[] = [
      { id: "info", label: "Product Info", icon: <Inventory2Outlined fontSize="small" /> },
    ];
    if (canEditProductConfig) {
      tabs.push({ id: "config", label: "Product Config", icon: <TuneOutlined fontSize="small" />, disabled: lockOtherTabs });
    }
    tabs.push({ id: "catalog", label: "Product Catalog", icon: <HubOutlined fontSize="small" />, disabled: lockOtherTabs });
    if (!watchedHasSKUPrice) {
      tabs.push({ id: "pricing", label: "Product Pricing", icon: <AttachMoneyOutlined fontSize="small" />, disabled: lockOtherTabs });
    }
    if (canViewProductShipping) {
      tabs.push({ id: "shipping", label: "Product Shipping", icon: <LocalShippingOutlined fontSize="small" />, disabled: lockOtherTabs });
    }
    tabs.push({ id: "document", label: "Product Document", icon: <DescriptionOutlined fontSize="small" />, disabled: lockOtherTabs });
    if (isSuperAdmin && isPurchaseAndBillEnabled) {
      tabs.push({ id: "cogs", label: "Product COGs", icon: <MonetizationOnOutlined fontSize="small" />, disabled: lockOtherTabs });
    }
    return tabs;
  }, [canEditProductConfig, canViewProductShipping, editForm, isPurchaseAndBillEnabled, isSuperAdmin, watchedHasSKUPrice]);

  useEffect(() => {
    if (!editForm && activeTab !== "info") {
      setActiveTab("info");
      return;
    }
    if (!productTabs.some((tab) => tab.id === activeTab)) {
      setActiveTab("info");
    }
  }, [activeTab, editForm, productTabs]);

  const selectedManufacturer = manufacturerInfoList?.find(
    mfr => mfr.manufacturerId === selectedManufacturerId
  );

   const primaryActionBtnSx = {
    ...primaryBtnSx,
    color: "#fff",
    "& .MuiTypography-root": {
      color: "#fff",
      fontWeight: 700,
    },
    "& .MuiButton-startIcon": {
      color: "#fff",
    },
    "& .MuiSvgIcon-root": {
      color: "#fff",
    },
  };

  const withPRUGuard = (fn: () => void) => () => {
    if (isRestrictedUser) {
      setShowPRUWarning({
        show: true,
        title: "Pre Registered User Warning",
        message: (
          <center>
            You don't have access to this feature. Please complete the practice
            registration in order to use the full system functionality.
          </center>
        ),
        variant: "warning",
        buttons: [
          {
            name: "Cancel",
            color: "error",
            icon: <Cancel sx={{ fontSize: "1rem" }} />,
            onClick: () => setShowPRUWarning({ show: false, message: "" }),
          },
          ...(isRestrictedUser && userInfo?.associatedPracticeStatus === "PENDING"
            ? [
                {
                  name: "Complete Registration",
                  color: "success" as const,
                  onClick: () => {
                    setRegistrationModalOpen(true);
                    setShowPRUWarning({ show: false, message: "" });
                  },
                },
              ]
            : []),
        ],
      });
      return;
    }
    fn();
  };

  const productConfigRules = useMemo(() => {
    if (editForm) {
      if (savedProductConfigRules) return savedProductConfigRules;
      if (fetchedProductConfigRules.length > 0) return fetchedProductConfigRules;
      return productObject?.configRules ?? [];
    }
    return draftProductConfigRules ?? [];
  }, [draftProductConfigRules, editForm, fetchedProductConfigRules, productObject?.configRules, savedProductConfigRules]);

  const getProductConfigValue = useCallback((configType: string, configCode: string): string | null => {
    const rule = productConfigRules.find(
      (r: ProductConfigRules) => r.configType === configType && r.configCode === configCode
    );
    return rule?.value || null;
  }, [productConfigRules]);

  const orderMarketProduct = useMemo<MarketProduct | null>(() => {
    if (actionMarketProduct) return actionMarketProduct;
    if (!editForm || !productObject?.productId) return null;
    const agreementMode = getProductConfigValue(PRODUCT_CONFIG_TYPE.AGREEMENT, PRODUCT_CONFIG_CODE.MODE);
    return {
      productId: productObject.productId,
      productName: productObject.productName,
      hcpcsCode: productObject.hcpcsCode,
      productCategory: productObject.productCategory || null,
      composition: productObject.composition,
      compoundType: productObject.compoundType,
      allowableRate: null,
      listPrice: null,
      mues: productObject.mues || null,
      manufacturerId: productObject.manufacturerId ?? selectedManufacturer?.manufacturerId ?? null,
      manufacturerName: selectedManufacturer?.manufacturerName || "N/A",
      isAgreementRequired: agreementMode === PRODUCT_CONFIG_VALUE.MANDATORY,
      agreementStatus: null,
      agreementMode,
      productLogoId: null,
      isFavorited: false,
      productStatus: productObject.productStatus || null,
      hasSKUPrice: productObject.hasSKUPrice,
      purchaseAndBill: productObject.purchaseAndBill ?? null,
      productConfigs: productConfigRules,
      productDescription: productObject.productDescription,
    };
  }, [actionMarketProduct, editForm, getProductConfigValue, productConfigRules, productObject, selectedManufacturer]);

  const rxMarketProduct = useMemo<MarketProduct | null>(() => {
    if (!actionMarketProduct) return null;
    return {
      ...actionMarketProduct,
      skuAllowablePrices: actionMarketProduct.skuAllowablePrices ?? [],
      agreementMode:
        actionMarketProduct.agreementMode ??
        (actionMarketProduct.isAgreementRequired ? PRODUCT_CONFIG_VALUE.MANDATORY : null),
    };
  }, [actionMarketProduct]);

  const placeOrderActionFlags = useMemo(() => {
    if (actionMarketProduct) {
      return getExploreMarketProductActionFlags({
        productCategory: actionMarketProduct.productCategory,
        agreementRequired: actionMarketProduct.isAgreementRequired,
        agreementStatus: actionMarketProduct.agreementStatus,
        agreementApproved: actionMarketProduct.agreementStatus === "APPROVED",
        productStatus: actionMarketProduct.productStatus,
        productConfigs: actionMarketProduct.productConfigs,
        canCreateOrder,
        canRequestAgreement,
      });
    }
    const rawCategory = String(watchedProductCategory || productObject?.productCategory || "");
    const mappedCategory = mapCategoryLabel(rawCategory);
    const productCategory =
      mappedCategory === PRODUCT_CATEGORY.STANDARD ||
      mappedCategory === PRODUCT_CATEGORY.GENERAL ||
      mappedCategory === PRODUCT_CATEGORY.ADVANCED ||
      mappedCategory === PRODUCT_CATEGORY.CONSERVATIVE
        ? mappedCategory
        : rawCategory;
    return getExploreMarketProductActionFlags({
      productCategory,
      agreementRequired:
        getProductConfigValue(PRODUCT_CONFIG_TYPE.AGREEMENT, PRODUCT_CONFIG_CODE.MODE) ===
        PRODUCT_CONFIG_VALUE.MANDATORY,
      agreementStatus: null,
      agreementApproved: false,
      productStatus: productObject?.productStatus,
      productConfigs: productConfigRules,
      canCreateOrder,
      canRequestAgreement,
    });
  }, [
    actionMarketProduct,
    canCreateOrder,
    canRequestAgreement,
    getProductConfigValue,
    productConfigRules,
    productObject?.productCategory,
    productObject?.productStatus,
    watchedProductCategory,
  ]);

  const recordRxActionFlags = useMemo(() => {
    if (!actionMarketProduct) return null;
    return getExploreMarketProductActionFlags({
      productCategory: actionMarketProduct.productCategory,
      agreementRequired: actionMarketProduct.isAgreementRequired,
      agreementStatus: actionMarketProduct.agreementStatus,
      agreementApproved: actionMarketProduct.agreementStatus === "APPROVED",
      productStatus: actionMarketProduct.productStatus,
      productConfigs: actionMarketProduct.productConfigs,
      canCreateOrder,
      canRequestAgreement,
    });
  }, [actionMarketProduct, canCreateOrder, canRequestAgreement]);

  const placeOrderActionsReady =
    editForm &&
    !!productObject?.productId &&
    actionMarketProduct !== undefined &&
    (actionMarketProduct !== null || productConfigLoaded);
  const showOrderButton =
    placeOrderActionsReady && placeOrderActionFlags.visibleAction === "order";
  const showRequestRxButton =
    editForm &&
    !!productObject?.productId &&
    actionMarketProduct != null &&
    recordRxActionFlags != null &&
    recordRxActionFlags.visibleAction === "rx";

  const handleOrderProduct = useCallback(() => {
    setOrderOpen(true);
  }, []);

  const handlePrescribeProduct = useCallback(() => {
    setIsOpenPrescription(true);
  }, []);

  const handlePlaceOrderClick = useCallback(() => {
    withPRUGuard(() => {
      if (!orderMarketProduct) return;
      handleOrderProduct();
    })();
  }, [handleOrderProduct, orderMarketProduct, isRestrictedUser, userInfo]);

  const handleRecordRxClick = useCallback(() => {
    withPRUGuard(() => {
      if (!rxMarketProduct) return;
      handlePrescribeProduct();
    })();
  }, [handlePrescribeProduct, rxMarketProduct, isRestrictedUser, userInfo]);

  const handleSubmitPrescription = async (payload: any): Promise<any[] | null> => {
    if (payload) {
      const result = await dispatch(submitPrescription({ request: payload, skipLoader: false }));
      if (result?.payload?.data?.length === 0) {
        setShowInfoPopup({ message: result?.payload?.message, show: true, title: "Error Occurred While Submitting the Rx Request" });
      }
      return result?.payload?.data ?? null;
    }
    return null;
  };

  const manufacturersList = useMemo(() => {
    let options: { label: string, value: any }[] = [];
    manufacturerInfoList?.map((option) => {
      options.push({ label: option.manufacturerName, value: option.manufacturerId })
    });
    return options;
  }, [manufacturerInfoList]);

  const compoundTypeOptions = useMemo(
    () => [
      { label: "Sterile", value: "sterile" },
      { label: "Non-Sterile", value: "non-sterile" },
    ],
    []
  );

  const discounts = useMemo(() => {
    if (allCodeTablesValuesMap)
      return getCodeTableValuesByTableName(allCodeTablesValuesMap, "ProductDiscount")
    return [];
  }, [allCodeTablesValuesMap]);

  const tierCodeRows = useMemo(() => {
    const values = getCodeTableValuesByTableName(allCodeTablesValuesMap as any, TIER_PRICE_CODETABLE);
    return Array.isArray(values) ? values : [];
  }, [allCodeTablesValuesMap]);

  const tierPriceValue = (value: any) => {
    if (value && typeof value === "object" && "price" in value) {
      return value.price;
    }
    return value;
  };

  const hasTierPrices = (tierPrices: any) => {
    if (!tierPrices || typeof tierPrices !== "object") {
      return false;
    }
    return Object.values(tierPrices).some((value) => {
      const price = tierPriceValue(value);
      return price !== null && price !== undefined && String(price).trim() !== "";
    });
  };

  const tierKeys = useMemo(() => tierCodeRows.map((row) => row.keyName).filter(Boolean), [tierCodeRows]);
  const tierLabel = (key: string) => tierCodeRows.find((row) => row.keyName === key)?.displayValue || key;
  const viewTierOptions = tierCodeRows
    .filter((row) => row.keyName === editingViewTier || !viewTierRows.some((item) => item.tier === row.keyName))
    .map((row) => ({ label: row.displayValue || row.keyName, value: row.keyName }));

  const rowsFromTierPrices = (tierPrices?: Record<string, any> | null) => {
    if (!tierPrices || typeof tierPrices !== "object") {
      return [];
    }
    const keysInData = Object.keys(tierPrices).filter((key) => {
      const price = tierPriceValue(tierPrices[key]);
      return price !== null && price !== undefined && String(price).trim() !== "";
    });
    const ordered = [
      ...tierCodeRows.map((row) => row.keyName).filter((key) => keysInData.includes(key)),
      ...keysInData.filter((key) => !tierCodeRows.some((row) => row.keyName === key)),
    ];
    return ordered.map((key) => ({ tier: key, price: String(tierPriceValue(tierPrices[key])) }));
  };

  const openTierPriceDialog = (data: any) => {
    setViewTierRows(rowsFromTierPrices(data?.tierPrices));
    setShowViewTierEditor(false);
    setEditingViewTier(null);
    setTierPriceTarget({ productPriceId: data?.productPriceId });
  };

  useEffect(() => {
    if (!showViewTierEditor) {
      return;
    }
    const remaining = tierKeys.filter((tier) => !viewTierRows.some((item) => item.tier === tier));
    const editingRow = viewTierRows.find((row) => row.tier === editingViewTier);
    viewTierForm.reset({
      tier: editingViewTier ?? remaining[0] ?? "",
      price: editingRow?.price ?? "",
    });
  }, [showViewTierEditor, editingViewTier]);

  // added discount prices to the ProductItemPrice table data
  const generateProductItemPriceRows = useCallback((productPrices: any) => {
    let modifiedArray: any[] = [];
  
    // Ensure productPrices is an array
    if (Array.isArray(productPrices)) {
      // Use forEach to modify and push into the array directly
      productPrices.forEach((obj: any) => {
        let modifiedObj = setDiscountPricesToTable(obj, discounts);
        
        if (modifiedObj.priceType === "MAC") {
          let macName = macInfoList?.find(option => option.macId === obj.macId)?.macName;
          modifiedObj["priceType"] = "Local Fee Schedule" + (macName ? " - " + macName : "");
        } else if (modifiedObj.priceType === "NATIONAL") {
          modifiedObj["priceType"] = "National";
        }
  
        // Push the modified object to the array
        modifiedArray.push(modifiedObj);
      });
    } else {
      console.warn("Invalid productPrices:", productPrices); 
    }
  
    return modifiedArray;
  }, [discounts, macInfoList, canManageTierPrice]);
  
  
  // added discount prices to the ProductItemPrice table data
  const generateProductItemPriceRowsOnAdd = useCallback((productPrices: any) => {
  
    // Wrap the entire object in a single-element array if it's defined
    const productPricesArray = productPrices ? [productPrices] : [];
  
    let modifiedArray: any[] = [];
  
    // Use forEach to modify and push into the array directly
    productPricesArray &&  productPricesArray.forEach(obj => {
      let modifiedObj = setDiscountPricesToTable(obj, discounts);
      if (modifiedObj.priceType === "MAC") {
        let macName = macInfoList?.find(option => option.macId === obj.macId)?.macName;
        modifiedObj["priceType"] = "Local Fee Schedule" + (macName ? " - " + macName : "");
      } else if (modifiedObj.priceType === "NATIONAL") {
        modifiedObj["priceType"] = "National";
      }
  
      // Push the modified object to the array
      modifiedArray.push(modifiedObj);
    });
  
    // Ensure you're returning the modified array
    return modifiedArray;
  
  }, [discounts, macInfoList, canManageTierPrice]);

  const generateProductItemsRows = useCallback((productItems: any) => {
    let modifiedArray: any[] = [];
    productItems?.forEach((obj: any) => {
      modifiedArray.push({
        ...obj,
        listPrice: (
          <CustomCurrencyField
            externalValue={obj.listPrice}
            displayType="text"
          />
        ),
        customPrice: (
          <CustomCurrencyField
            externalValue={obj.customPrice}
            displayType="text"
          />
        ),
        allowableUnitPrice: (
          <CustomCurrencyField
            externalValue={obj.allowableUnitPrice}
            displayType="text"
          />
        )
      });
    });
    return modifiedArray;
  }, []);

  const setDiscountPricesToTable = (data: any, discounts: CodeTable[]) => {
    let obj = {
      ...data,
      listPrice: <CustomCurrencyField externalValue={data?.listPrice} displayType="text" />,
      customPrice: <CustomCurrencyField externalValue={data?.customPrice} displayType="text" />,
      tierPrice: canManageTierPrice ? (
        <Link
          component="button"
          underline="hover"
          variant="body2"
          onClick={(event) => {
            event.stopPropagation();
            openTierPriceDialog(data);
          }}
        >
          {hasTierPrices(data?.tierPrices) ? "View Tier Price" : "Add Tier Price"}
        </Link>
      ) : "-",
      allowableUnitPrice: <CustomCurrencyField externalValue={data?.allowableUnitPrice} displayType="text" />,
      inactiveDate: data.inactiveDate  ? data.inactiveDate : "-"

    }
    discounts?.map((discount) => {
      obj[discount.displayValue] = <CustomCurrencyField externalValue={calculateValue(discount.displayValue, data?.allowableUnitPrice)} displayType="text" />
    })
    return obj;
  }

  const tierPricesFromRows = (rows: { tier: string; price: string }[]) => {
    const tierPrices: Record<string, number> = {};
    rows.forEach((row) => {
      const price = Number(row.price);
      if (!Number.isNaN(price)) {
        tierPrices[row.tier] = price;
      }
    });
    return tierPrices;
  };

  const saveViewTierRows = async (rows: { tier: string; price: string }[]) => {
    const tierPrices = tierPricesFromRows(rows);
    const productPriceId = tierPriceTarget?.productPriceId;
    const prices = getValues("productPrices") || [];
    if (productPriceId != null) {
      const nextPrices = prices.map((price: any) =>
        String(price.productPriceId) === String(productPriceId) ? { ...price, tierPrices } : price
      );
      setValue("productPrices", nextPrices);
      setProductPriceRows(generateProductItemPriceRows(nextPrices));
    }
    if (editForm && productPriceId) {
      try {
        await updateProductTierPrices(Number(productPriceId), tierPrices);
      } catch (error) {
        dispatch(setSingleAlertObj({ message: "Tier price could not be saved.", alertType: "error" }));
      }
    }
  };

  const openViewTierEditor = () => {
    setEditingViewTier(null);
    setShowViewTierEditor(true);
    const remaining = tierKeys.filter((tier) => !viewTierRows.some((item) => item.tier === tier));
    viewTierForm.reset({ tier: remaining[0] ?? "", price: "" });
  };

  const saveViewTierRow = (data: { tier: string; price: string }) => {
    const price = (data.price ?? "").trim();
    if (!data.tier || !price) {
      return;
    }
    const nextRows = [
      ...viewTierRows.filter((row) => row.tier !== editingViewTier && row.tier !== data.tier),
      { tier: data.tier, price },
    ];
    setViewTierRows(nextRows);
    setShowViewTierEditor(false);
    void saveViewTierRows(nextRows);
  };

  const deleteViewTierRow = (tier: string) => {
    setTierDeletePopup({
      message: `Are you sure you want to delete the ${tierLabel(tier)} tier price?`,
      show: true,
      variant: "confirm",
      buttons: [
        {
          name: "Yes",
          color: "primary",
          onClick: () => {
            const nextRows = viewTierRows.filter((row) => row.tier !== tier);
            setViewTierRows(nextRows);
            setTierDeletePopup({ message: "", show: false });
            void saveViewTierRows(nextRows);
          },
        },
        { name: "No", color: "error", onClick: () => setTierDeletePopup({ message: "", show: false }) },
      ],
    });
  };

  //mount
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    let id = urlSearchParams.get('id');
    if (id) {
      setEditForm(true);
      dispatch(getProduct({ productId: parseInt(id) }));
      dispatch(fetchProductDocumentsByProductId(parseInt(id)));
    } else {
      // CS-1760 - isAgreementRequired no longer set here, driven by Product Config AGREEMENT MODE
      setValue("productStatus", "TBD");
    }
    dispatch(fetchMac());
    dispatch(fetchManufacturersList());
  }, []);

  // unmount
  useEffect(() => () => {
    dispatch(resetCreateProductSlice());
  }, []);

//collagen kit task cs-715 start
  const selectedProductCategorys = watch('productCategory') || "";
  useEffect(() => {
    setSelectedProductCategory(selectedProductCategorys);  
  }, [selectedProductCategorys]); 
  //end

  const watchedComposition = watch("composition") || "";
  const [showGlpNotice, setShowGlpNotice] = useState(false);
  const isGlpProduct =
    selectedProductCategorys === PRODUCT_CATEGORY.GENERAL &&
    watchedComposition.toLowerCase().includes("glp");
  const isPharmacyManufacturer = !!selectedManufacturer?.isPharmacy;
  const pharmacyDisplayName =
    selectedManufacturer?.manufacturerName?.trim() || "the pharmacy";
  const shouldShowCompoundedNotice =
    isGlpProduct && isPharmacyManufacturer && showGlpNotice;

  useEffect(() => {
    if (isGlpProduct && isPharmacyManufacturer) {
      setShowGlpNotice(true);
    }
  }, [isGlpProduct, isPharmacyManufacturer, selectedManufacturerId]);

  const selectedManufacture = Number(watch('manufacturerId')) || 0; 
  useEffect(() => {
    setSelectedProductManufacture(selectedManufacture);  
  }, [selectedManufacture]); 

  useEffect(() => {
    if (productObject.productId > 0 && getProductStatus === "success") {
      let productObj = { ...productObject };

      let docObj: DocumentItemInfo = {
        documentId: 0,
        documentName: "",
        type: "",
        fileType: "",
        content: ""
      };

      if (productObj.documents && productObj.documents.length > 0) {
        for (let i: number = 0; i < productObj.documents.length; i++) {
          docObj = productObj.documents[i];
          if (docObj && docObj.type === "PRODUCTLOGO" && docObj.content && docObj.content.length > 0) {
            productObj.productLogo = "data:image/png;base64," + docObj.content;
          }
        }
      }
      reset(productObj);
      setProductItemRows(generateProductItemsRows((productObject.productItems)))
      if(saveProductPriceStatus ==="success"){
        setProductPriceRows(generateProductItemPriceRowsOnAdd(productObject.productPrices?productObject.productPrices.newProductPrice:productObject.productPrices))
      }else if (Array.isArray(productObject.productPrices)){
        setProductPriceRows(generateProductItemPriceRows(productObject.productPrices))
      }
    }
  }, [productObject, getProductStatus,saveProductPriceStatus]);

  useEffect(() => {
    if (editForm) {
      setDraftProductConfigRules([]);
      setDraftProductPurchasePrices([]);
    }
  }, [editForm]);

  useEffect(() => {
    setSavedProductConfigRules(null);
    setFetchedProductConfigRules([]);
    setProductConfigLoaded(false);
    setActionMarketProduct(undefined);
  }, [productObject?.productId]);

  useEffect(() => {
    const productId = productObject?.productId;
    if (!editForm || !productId) return;

    let cancelled = false;
    getProductConfigByProduct(productId)
      .then((response) => {
        if (cancelled) return;
        setFetchedProductConfigRules(response?.data?.data ?? []);
        setProductConfigLoaded(true);
      })
      .catch(() => {
        if (!cancelled) {
          setFetchedProductConfigRules([]);
          setProductConfigLoaded(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [editForm, productObject?.productId]);

  useEffect(() => {
    const productId = productObject?.productId;
    if (!editForm || !productId) {
      setActionMarketProduct(undefined);
      return;
    }

    const existing = (marketData || []).find((p: MarketProduct) => Number(p.productId) === Number(productId));
    if (existing) {
      setActionMarketProduct(existing);
      return;
    }

    let cancelled = false;
    dispatch(getExploreMarketProducts(false))
      .unwrap()
      .then((payload: any) => {
        if (cancelled) return;
        const list = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.data)
            ? payload.data
            : [];
        const found = list.find((p: any) => Number(p.productId) === Number(productId));
        setActionMarketProduct(found || null);
      })
      .catch(() => {
        if (!cancelled) setActionMarketProduct(null);
      });

    return () => {
      cancelled = true;
    };
  }, [dispatch, editForm, marketData, productObject?.productId]);

  useEffect(()=>{
    if (saveProductItemStatus === "success"){
      setValue("productItems", productObject.productItems);
      setProductItemRows(generateProductItemsRows((productObject.productItems)));
    }
  },[saveProductItemStatus])

  useEffect(()=>{
    if (saveProductPriceStatus === "success"){
      setProductPriceRows(generateProductItemPriceRowsOnAdd(productObject.productPrices?productObject.productPrices.newProductPrice:productObject.productPrices))
      setShowProductAgreementPopup(true)
    }
  },[saveProductPriceStatus])

  useEffect(() => {
    if (!showProductItemPopup)
      setProductItemObject(initialValuesOfProductItem);
  }, [showProductItemPopup]);

  useEffect(() => {
    if (!showProductItemPricePopup)
      setPriceItemObject(initialValuesOfProductItemPrice);
  }, [showProductItemPricePopup]);

  useEffect(() => {
    if (createProductStatus === "success") {
      let Obj: SingleAlertInfo = {
        title: "Success",
        message: `Product: ${getValues("productName")} has been created successfully.`,
        alertType: "success",
      }
      dispatch(setSingleAlertObj(Obj));
    }
    else if (createProductStatus === "error") {
      let Obj: SingleAlertInfo = {
        title: "Error",
        message: `Product: ${getValues("productName")} creation unsuccessful.`,
        alertType: "error",
      }
      dispatch(setSingleAlertObj(Obj));
    }
  }, [createProductStatus]);

  useEffect(()=>{
    if (updateProductStatus ==="success"){
      let Obj: SingleAlertInfo = {
        title: "Success",
        message: "Successfully updated the product details",
        alertType:"success",
      }
      dispatch(setSingleAlertObj(Obj));
    }
    if (saveProductLogoStatus ==="success"){
      let Obj: SingleAlertInfo = {
        title: "Success",
        message: "Successfully save the product logo",
        alertType:"success",
      }
      dispatch(setSingleAlertObj(Obj))
    }
    setTimeout(()=>{
      dispatch(hideSingleAlert());
    },5000)
    dispatch(resetFetchStatus());
  },[updateProductStatus, saveProductLogoStatus]);

  useEffect(() => {
    if(inactivateProductDocumentStatus === 'success') {
      setShowDocInactivePopup({
        isShow: false,
        productId: 0,
        manufacturerId: null,
        documentId: 0
      });
      let Obj: SingleAlertInfo = {
        title: "Success",
        message: "Successfully inactivated the product document",
        alertType:"success",
      }
      dispatch(setSingleAlertObj(Obj));
      dispatch(updateElementInProductSlice({
        elementName: 'inactivateProductDocumentStatus',
        value: 'idle'
      }));
      dispatch(fetchProductDocumentsByProductId(productObject?.productId));
    }
  }, [inactivateProductDocumentStatus]);

  const onConfirmInactivateProductPrice = useCallback(async (obj: { date: string, productPriceId: number }) => {
    setOptionPopupShow({ message: "", show: false });
    continueInactivateFuther(obj.date, obj.productPriceId);
  }, []);

  const continueInactivateFuther = useCallback((date: string, productPriceId: number) => {
    dispatch(inactivateProductPrice({ productPriceId: productPriceId, date: date }));
    closePricingPopup();
  }, []);

  const onInactivePriceClick = useCallback((row: any, rowIndex: number) => {
    setTableRowIndex(rowIndex);
    setEditItem(true);
    setInactiveOnly(true);
    setPriceItemObject(watch("productPrices") ? getValues("productPrices")[rowIndex] : initialValuesOfProductItemPrice);
    setShowProductItemPricePopup(true);
  }, []);

  const onEditClick = useCallback((row: any, rowIndex: number, fieldName: string) => {
    setTableRowIndex(rowIndex);
    setEditItem(true);
    if (fieldName === "productItems") {
      setProductItemObject(row);
      setShowProductItemPopup(true);
    } else if (fieldName === "productPrices") {
      setPriceItemObject(watch("productPrices")?getValues("productPrices")[rowIndex]: initialValuesOfProductItemPrice);
      setShowProductItemPricePopup(true);
    }
  }, []);

  const onDeleteProductItemClick = useCallback((rowIndex: number) => {
    let existingProductItem = getValues("productItems");
    existingProductItem.splice(rowIndex, 1);
    setValue("productItems", existingProductItem);
    setProductItemRows(generateProductItemsRows((existingProductItem)));
  }, []);

  const onDeleteProductPriceClick = useCallback((rowIndex: number, productPriceId: number ,practiceProducts:number) => {
    if (productPriceId ) {
      if(productPriceId> 0 && practiceProducts===0){
      setOptionPopupShow({
        message: "Do you really want to delete this price?",
        show: true,
        variant: "custom",
        title: "Confirm",
        buttons: [{ name: "YES", color: 'primary', onClick: onConfirmDeleteProductPrice }, { name: "NO", color: 'secondary', onClick: cancelOptionPopup }],
        obj: {rowIndex: rowIndex, productPriceId: productPriceId}
      })}else{
         let errorObj: SingleAlertInfo = {
                message: "Product Price can not be deleted as it is associated with agreement!",
                alertType: "error",
              };
              dispatch(setSingleAlertObj(errorObj));
      }
    } else {
      removeProductPriceFromTable(rowIndex);
    }
  }, []);

  const onConfirmDeleteProductPrice = useCallback(async (obj: { rowIndex: number, productPriceId: number }) => {
    setOptionPopupShow({ message: "", show: false });

    try {
      let response = await dispatch(deleteProductPriceObj({ productPriceId: obj.productPriceId }));
      
      if (response.payload && response.payload.code === "V3OK" && response.payload.message === "SUCCESS"
        && (!response.payload.errors || response.payload.errors.length === 0)) {
        let Obj: SingleAlertInfo = {
          title: "Success",
          message: "Successfully deleted the pricing.",
          alertType: "success",
        }
        dispatch(setSingleAlertObj(Obj));
      }
    } catch (error) {
      console.log("response.error");
      console.log(error);
    }
  }, []);

  const removeProductPriceFromTable = useCallback((rowIndex: number) => {
    let existingProductItemPrice = getValues("productPrices");
    existingProductItemPrice.splice(rowIndex, 1);
    setValue("productPrices", existingProductItemPrice);
    setProductPriceRows(generateProductItemPriceRows(existingProductItemPrice));
  }, []);

  const addProductItem = useCallback((productItem: ProductItemInfo) => {
    if (editForm){
      saveProductItems(productItem)
    }else {
      let existingProductItem = getValues("productItems");
      if (tableRowIndex !== undefined && tableRowIndex !== null && tableRowIndex >= 0) {
        existingProductItem[tableRowIndex] = productItem;
        setValue("productItems", existingProductItem);
        setProductItemRows((existingProductItem))

      } else if (existingProductItem) {
        setValue("productItems", [...existingProductItem, productItem]);
        setProductItemRows(([...existingProductItem, productItem]))
      } else {
        setValue("productItems", [productItem]);
        setProductItemRows(([productItem]))
      }
    }
    setTableRowIndex(null);
  }, [watch("productItems"), tableRowIndex, editForm, productObject.productId]);

  const addProductItemPrice = useCallback((productItemPrice: ProductItemPriceInfo) => {
    if (editForm) {
      if (inactiveOnly) {
        if ((!productItemPrice.practiceProducts || productItemPrice.practiceProducts.length === 0)) {
          continueInactivateFuther(productItemPrice.inactiveDate, productItemPrice.productPriceId);
        } else {
          setOptionPopupShow({
            message: productItemPrice.practiceProducts.length + " number of agreements will be inactivated effective of " + productItemPrice.inactiveDate + " do you want to continue?",
            show: true,
            variant: "custom",
            title: "Confirm",
            buttons: [{ name: "YES", color: 'primary', onClick: onConfirmInactivateProductPrice }, { name: "NO", color: 'secondary', onClick: cancelOptionPopup }],
            obj: {date: productItemPrice.inactiveDate, productPriceId: productItemPrice.productPriceId}
          });
        }
      } else {
        saveProductPriceItems(productItemPrice);
        closePricingPopup();
      }
    } else {
      let existingProductItemPrice = getValues("productPrices");
      if (tableRowIndex !== undefined && tableRowIndex !== null && tableRowIndex >= 0) {
        existingProductItemPrice[tableRowIndex] = productItemPrice;
        setValue("productPrices", existingProductItemPrice);
        setProductPriceRows(generateProductItemPriceRows(existingProductItemPrice))
      } else if (existingProductItemPrice) {
        setValue("productPrices", [...existingProductItemPrice, productItemPrice]);

        setProductPriceRows(generateProductItemPriceRows([...existingProductItemPrice, productItemPrice]))
      } else {
        setValue("productPrices", [productItemPrice]);

        setProductPriceRows(generateProductItemPriceRows([productItemPrice]))
      }
      closePricingPopup();
    }
  }, [watch("productPrices"), tableRowIndex, productObject.productId, macInfoList]);

  const saveProductItemsPrices = useCallback((productPricesItems: any[]) =>{
    //api call
    const productPriceItems = {
      ProductItemPrices: productPricesItems,
      productId: productObject.productId
    }
    dispatch(saveAllProductItemsPrices({productPriceItems: productPriceItems}));
  }, [productObject])

  const addProductItemsPrice = useCallback((productItemPrice: any) => {
    const transformedData = productItemPrice.productItems.map((item: any) => ({
      ...item,
      effectiveDate: productItemPrice.effectiveDate,
      inactiveDate: productItemPrice.inactiveDate,
      priceType: "NATIONAL"
    }));

    let existingProductItems = getValues("productItems");

    // Update existingProductItems with prices from transformedData
    const updatedProductItems = existingProductItems.map((existingItem: any) => {
      const matchingItem = transformedData.find(
        (transformedItem: any) => transformedItem.sku === existingItem.sku
      );
      if (matchingItem) {
        return {
          ...existingItem,
          listPrice: matchingItem.listPrice,
          customPrice: matchingItem.customPrice,
          allowableUnitPrice: matchingItem.allowableUnitPrice,
          effectiveDate: matchingItem.effectiveDate
        };
      }
      return existingItem;
    });
    
    if (editForm) {
      saveProductItemsPrices(transformedData);
    }
    setValue("productItems", updatedProductItems);
    setProductItemRows(generateProductItemsRows((updatedProductItems)))
    closeItemsPricingPopup();
    
  }, [watch("productPrices"), tableRowIndex, productObject.productId]);

  const closePricingPopup = useCallback(() => {
    setShowProductItemPricePopup(false);
    setTableRowIndex(null);
    setEditItem(false);
    setInactiveOnly(false);
  }, []);

  const closeItemsPricingPopup= useCallback(() => {
    setShowProductItemsPricePopup(false);
    setTableRowIndex(null);
    setEditItem(false);
    setInactiveOnly(false);
  }, []);

  const saveProductItems = useCallback((productItem: ProductItemInfo) =>{
    let Obj: ProductItemInfo= {
      ...productItem,
      inactiveDate: productItem.inactiveDate? moment(productItem.inactiveDate?.toString())?.format("MM/DD/YYYY") : "",
      productId: productObject.productId,
    };
    dispatch(saveProductItem({productItem: Obj}))
  }, [productObject]);

  const saveProductPriceItems = useCallback((productPriceItem: ProductItemPriceInfo) =>{
    let Obj: ProductItemsPriceInfo= {
      ProductItemPrices: [productPriceItem],
      productId: productObject.productId,
    }

    dispatch(saveProductPriceItem({productPriceItem: Obj}));
  }, [productObject])

  const handleDropzoneChange = async (uploadedFiles: File, fieldName: any) => {
    let base64File = "";
    let fileName: string = "";
    if (uploadedFiles) {
      base64File = String(await convertBase64(uploadedFiles));
      fileName = uploadedFiles.name;
    }
    setValue(fieldName, base64File);
    
    let existingdocuments: DocumentItemInfo[] = getValues("documents");

    let docObj : DocumentItemInfo = {
      documentId: 0,
      documentName: "",
      type: "",
      fileType: "",
      content: ""
    };

    if (existingdocuments) {
      
        docObj = existingdocuments[0];
        if (fieldName === "productLogo" && docObj.type === "PRODUCTLOGO") {
          docObj.documentName = fileName;
          docObj.fileType = "png";
        } else {
          docObj.type = "PRODUCTLOGO";
          docObj.documentName = fileName;
          docObj.fileType = "png";

          existingdocuments.push(docObj);
        }
      
    } else {
      existingdocuments = [];
      docObj.type = "PRODUCTLOGO";
      docObj.documentName = fileName;
      docObj.fileType = "png";

      existingdocuments.push(docObj);
    }

    setValue("documents", existingdocuments);
    if (editForm){
      docObj.content = base64File && base64File.length > 23
      ? base64File.substring("data:image/png;base64,".length, base64File.length) : base64File;
      dispatch(saveProductLogo({logoData: {productLogoId: docObj.documentId,productId: productObject.productId, document: docObj}}));
    }
  }

  const convertBase64 = (file: any) => {
    return new Promise((resolve) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    });
  }

  const confirmOptionPopup = () => {
    handleSubmit(updateProduct)()
    setOptionPopupShow({ message: "", show: false });
  }

  const cancelOptionPopup = () => {
    setOptionPopupShow({ message: "", show: false });
  }

  const updateProduct = (data: ProductInfo) =>{
    let Obj = {
      productId: data.productId,
      manufacturerId: data.manufacturerId,
      productName: data.productName,
      hcpcsCode: data.hcpcsCode,
      inactiveDate: data.inactiveDate ? dayjs(data.inactiveDate).format("MM/DD/YYYY") : "",
      productDescription: data.productDescription,
      composition: data.composition,
      compoundType: data.compoundType || null,
      insuranceCoverage: data.insuranceCoverage,
      // CS-1760 - isAgreementRequired removed, now driven by Product Config AGREEMENT MODE
      mues: data.mues,
      productCategory: mapCategoryLabel(data.productCategory),
      productStatus: data.productStatus,
      hasSKUPrice: data.hasSKUPrice,
      iskit:data.isKit,
    }
    dispatch(updateProductDetails({product: Obj}));
  }

  const openPriceAddingPopup = useCallback(() => {
    let existingProductPriceList = getValues("productPrices");
    if (!editForm && existingProductPriceList && existingProductPriceList.length > 0) {
      for (let i: number = 0; i < existingProductPriceList.length; i++) {
        if (existingProductPriceList[i].priceType === "NATIONAL") {
          let errorObj: SingleAlertInfo = {
            message: "A National pricing is already exists. If you want to change pricing please update existing one or delete it first.",
            alertType: "error",
          };
          dispatch(setSingleAlertObj(errorObj));
          return;
        }
      }
    }
    setShowProductItemPricePopup(true);
  }, [editForm, watch("productPrices")]);

  const openItemsPriceAddingPopup = useCallback(() => {
    if (getValues("productItems").length <= 0) {
      let Obj: SingleAlertInfo = {
        title: "warning",
        message: `Please add at least one product item to add pricing`,
        alertType: "warning",
      }
      dispatch(setSingleAlertObj(Obj));
    } else {
      const convertedPriceItmsObj : ProductItemsPriceInfo = {
        productId: productObject?.productId,
        ProductItemPrices: getValues("productItems")
      }
      setPriceItemsObject(watch("productItems")?convertedPriceItmsObj: initialValuesOfProductItemsPrice);
      setShowProductItemsPricePopup(true);
    }
  }, [editForm, watch("productItems")]);

  // Matches the OrderList table look — cyan headers, subtle row dividers, teal hover.
  const listBorderColor = isDark ? "rgba(148,163,184,0.2)" : "rgba(15,23,42,0.12)";
  const listHoverBg = isDark ? "rgba(20,184,166,0.09)" : "rgba(20,184,166,0.06)";
  const productTableSx = {
    border: `1px solid ${modalTokens.border}`,
    borderRadius: "10px",
    overflow: "hidden",
    p: 0,
    "& .MuiTableContainer-root": { borderRadius: "10px", border: "none", backgroundColor: "transparent" },
    "& table": {  borderCollapse: "collapse", borderSpacing: 0 },
    "& .MuiTableCell-root": { borderBottom: `1px solid ${listBorderColor}`, py: 1.15, fontSize: "0.84rem" },
    "& .MuiTableHead-root .MuiTableCell-root": { height: "42px"  },
    "& .MuiTableHead-root .MuiTypography-root": { color: "#00B8D9 !important", fontSize: "0.78rem", fontWeight: 800, letterSpacing: "0.02em" },
    "& .MuiTableBody-root .MuiTableRow-root": { transition: "background-color 0.18s ease, box-shadow 0.18s ease" },
    "& .MuiTableBody-root .MuiTableRow-root:hover": { backgroundColor: `${listHoverBg} !important` },
    "& .MuiTableBody-root .MuiTableCell-root": { color: modalTokens.textPrimary, fontSize: "0.84rem" },
    "& .MuiTableBody-root .MuiLink-root": { color: "#00B8D9 !important", fontWeight: 600, textDecorationColor: "rgba(0,184,217,0.45)" },
    "& .MuiTableBody-root .MuiLink-root:hover": { color: "#22d3ee !important", textDecorationColor: "#22d3ee" },
    "& .MuiTableBody-root .MuiTypography-root": { fontSize: "0.84rem" },
    "& .MuiIconButton-root": { color: isDark ? "#94a3b8" : "#475569", borderRadius: "8px", "&:hover": { color: modalTokens.accent, backgroundColor: isDark ? "rgba(20,184,166,0.12)" : "rgba(20,184,166,0.08)" } },
    "& .MuiPaginationItem-root": { borderColor: listBorderColor, color: modalTokens.textSecondary, borderRadius: "8px", "&.Mui-selected": { color: "#fff", backgroundColor: modalTokens.accent, borderColor: modalTokens.accent } },
  };

  const cancelButton = (
    <Button
      color="error"
      variant="outlined"
      size="small"
      startIcon={<CancelOutlined sx={{ fontSize: "1rem !important" }} />}
      onClick={() => navigate(-1)}
      sx={{
        ...cancelBtnSx,
        fontSize: "0.78rem",
        py: 1,
        px: 1.5,
        minWidth: "auto",
        borderRadius: "8px",
      }}
    >
      Cancel
    </Button>
  );

  const updateProductValues = () =>{
    {setOptionPopupShow({message: "Do You Really want to update product details? ", 
    show: true, 
    variant: "confirm", 
    buttons: [{name: "Confirm", color: 'primary', onClick:confirmOptionPopup },{name: "Cancel", color: 'secondary', onClick:cancelOptionPopup }]})}
  }

  const onSubmit = useCallback(async (data: ProductInfo) => {
    // Create flow — product updates use Update Product, not this submit handler.
    if (editForm) {
      return;
    }

    const { productDocumentStatus, ...submitObj } = data;

    let obj: ProductInfo = {
      ...submitObj,
      hcpcsCode:getValues("hcpcsCode")||null,
      productDescription:getValues("productDescription")||null,
      composition:getValues("composition")||null,
      compoundType: getValues("compoundType") || null,
      insuranceCoverage:getValues("insuranceCoverage")||null,
      productCategory: mapCategoryLabel(data.productCategory),
      hasSKUPrice: !!getValues("hasSKUPrice"),
      isKit: !!getValues("isKit"), ////collagen kit task cs-715
      inactiveDate: data.inactiveDate ? dayjs(data.inactiveDate).format("MM/DD/YYYY") : "",
      // Config is saved on the Product Config tab after create.
      configRules: undefined,
      productPurchasePrices: editForm ? undefined : draftProductPurchasePrices,
    }
    obj.saveMode = "FULLPRODUCT";
    let docObj : DocumentItemInfo = {
      documentId: 0,
      documentName: "",
      type: "",
      fileType: "",
      content: ""
    };

    if (obj.documents && obj.documents.length > 0) {
      for (let i: number = 0; i < obj.documents.length; i++) {
        docObj = obj.documents[i];
        if (docObj.type === "PRODUCTLOGO") {
          docObj.content = obj.productLogo && obj.productLogo.length > 23
            ? obj.productLogo.substring("data:image/png;base64,".length, obj.productLogo.length) : obj.productLogo;
          obj.productLogo = "";
        }
      }
    }

    // Stay on this page after create and continue to Product Config / Catalog tabs.
    const result = await dispatch(createProduct({ product: obj }));
    if (!createProduct.fulfilled.match(result)) {
      return;
    }

    const resp = result.payload;
    const responseData = resp?.data;
    const newProductId = Number(
      responseData?.productId ??
      responseData?.id ??
      (typeof responseData === "number" ? responseData : undefined) ??
      resp?.productId ??
      0
    );

    if (!newProductId || Number.isNaN(newProductId)) {
      return;
    }

    setEditForm(true);
    setDraftProductConfigRules([]);
    navigate(`/product?id=${newProductId}`);
    dispatch(getProduct({ productId: newProductId }));
    dispatch(fetchProductDocumentsByProductId(newProductId));
    setActiveTab(canEditProductConfig ? "config" : "catalog");
  }, [canEditProductConfig, draftProductPurchasePrices, editForm, getValues, navigate, dispatch]);

  // handle product document download
  const handleProductDocumentView = async (documentId: string, entityName: string) => {
    if (isDownloading.current) return;
    isDownloading.current = true;

    try {
      if (entityName && entityName === PRODUCTS_DOCUMENT_TYPE.PRODUCT_DOCUMENT) {
        const actionResult = await dispatch(fetchDocumentById(documentId));
        const documentData = actionResult.payload;
        if (documentData && documentData.content) {
          downloadBase64File(documentData.content, documentData.documentName, documentData.fileType);
        }
      } else if (entityName && entityName === PRODUCTS_DOCUMENT_TYPE.PRODUCT_TEMPLATE) {
        const actionResult = await dispatch(fetchTemplateById(documentId));
        const documentData = actionResult.payload;
        if (documentData && documentData.content) {
          downloadBase64File(documentData.content, documentData.templateFileName, 'image/jpeg');
        }
      } else {
        let errorObj: SingleAlertInfo = {
          message: 'No Document found for the product',
          alertType: 'error'
        };
        dispatch(setSingleAlertObj(errorObj));
      }
    } finally {
      isDownloading.current = false;
    }
  };
//collagen kit task cs-715
  const handleButtonClick = (row:any) => {
    setRowData(row); 
    setShowProductItemkitPopup(true)
  };
 
  // convert image string to byte array and download file
  const downloadBase64File = (base64String: string, fileName: string, mimeType: string) => {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const blobUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = blobUrl;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(blobUrl);
  }


//collagen kit task cs-715 for Manage Product Item
  const productItemActionComponent = useCallback((row: any, rowIndex: number,): JSX.Element => {
     const isKit = getValues("isKit");
    return (
      <>
        <CustomIconButton color="info" size="small" variant="outlined" onClick={() => onEditClick(row, rowIndex, "productItems")}
          tooltipMessage="Edit Item" tooltipPlacement='bottom'>
          <ModeOutlined fontSize="small" />
        </CustomIconButton>
        {
  (row.productItemId && 
   row.productItemId !== 0 && 
   isKit === true
  ) && (
    <CustomIconButton 
      color="info" 
      size="small" 
      variant="outlined"  
      onClick={() => handleButtonClick(row)}
      tooltipMessage="Manage Product Item" 
      tooltipPlacement="bottom" 
    >
      <ModeOutlined fontSize="small" />
    </CustomIconButton>
  )
}

          {(!row.productItemId || row.productItemId === 0) && (
            <CustomIconButton
              color="error"
              sx={{ pl: 2 }}
              size="small"
              variant="outlined"
              onClick={() => onDeleteProductItemClick(rowIndex)}
              tooltipMessage="Delete Item"
              tooltipPlacement="bottom"
            >
              <DeleteOutlineOutlined fontSize="small" />
            </CustomIconButton>
          )}

      </>
    );
  }, [editForm]);
 

  const priceItemActionComponent = useCallback((row: any, rowIndex: number): JSX.Element => {
    //
 /* {!editForm ? 
        <CustomIconButton color="info" size="small" variant="outlined" onClick={() => onEditClick(row, rowIndex, "productPrices")}
         tooltipMessage="Edit" tooltipPlacement='bottom'>
         <ModeOutlined fontSize="small" />
       </CustomIconButton>
        : null} */
 /* {editForm ?
         <>{" "}<CustomIconButton color="warning" size="small" variant="outlined"
           onClick={() => onInactivePriceClick(row, rowIndex)} 
           style={{ display: `${hideElement(row && dayjs(row.inactiveDate).isValid())}` }}
           tooltipMessage="Inactivate" tooltipPlacement='bottom'>
           <DoDisturbAltOutlined fontSize="small" />
         </CustomIconButton></>
         : null
       } */
  //
   return (
     <>
     <CustomIconButton
       color="error"
       size="small"
       variant="outlined"
       onClick={() => onDeleteProductPriceClick(rowIndex, row.productPriceId,row.practiceProducts?.length)}
       tooltipMessage="Delete"
       tooltipPlacement="bottom"
     >
       <DeleteOutlineOutlined fontSize="small" />
     </CustomIconButton>
   </>
)
 }, [editForm]);

  const productDocActionComponent = useCallback((row: ProductDocumentListInfo, rowIndex: number): JSX.Element => {
    return (
      <>
        <CustomIconButton color="info" size="small" variant="outlined" onClick={() => handleProductDocumentView(row.entityId, row.entityName)}
          tooltipMessage="Download" tooltipPlacement='bottom'>
          <Download />
        </CustomIconButton>
        {canInactivateProductDocument &&(
          <CustomIconButton color="warning" size="small" variant="outlined" onClick={() => {onDocInactiveClick(row)}}
            tooltipMessage="Inactivate" tooltipPlacement='bottom'>
            <DoDisturbAltOutlined />
          </CustomIconButton>
      )}
        {/* <CustomIconButton color="error" size="small" variant="outlined" onClick={() => {}}
          tooltipMessage="Delete" tooltipPlacement='bottom'>
          <DeleteOutlineOutlined fontSize="small" />
        </CustomIconButton> */}
      </>
    );
  }, [editForm]);

  const productTemplateActionComponent = useCallback((row: any, rowIndex: number): JSX.Element => {
    return (
      <>
        <CustomIconButton color="info" size="small" variant="outlined" onClick={() => handleProductDocumentView(row.entityId, row.entityName)}
          tooltipMessage="Download" tooltipPlacement='bottom'>
          <Download />
        </CustomIconButton>
      </>
    );
  }, [editForm]);

  const handleToggleButtonChange = useCallback((e: ChangeEvent<HTMLInputElement>, row: any, rowIndex: number) => {
    const newState = e.target.checked;
    const productItems = getValues('productItems');

    let productItem = productItems.find(pi => pi.productItemId === row.productItemId);
    productItem = productItem && {...productItem, isSizeActive: newState}
    productItem && saveProductItems(productItem);

    const alertObj: SingleAlertInfo = {
      message: newState ? "Product Item is now marked as Available." : "Product Item is now marked as Unavailable.",
      alertType: newState ? "success" : "warning",
    };
    dispatch(setSingleAlertObj(alertObj));

  }, [getValues, setValue, productObject]);

  const toggleAvailabilityButton = useCallback((row: any, rowIndex: number) => {
    const isInactivateSwitchToggled = row?.isSizeActive === null ? true : row.isSizeActive;

    return (
      <CustomSwitchButton
        controllerName={`isSizeActive.${rowIndex}`}
        control={control}
        checked={isInactivateSwitchToggled}
        onChange={(e) => handleToggleButtonChange(e, row, rowIndex)}
        // color="success"
        size="small"
        sx={{
          marginLeft: 2,
          "& .MuiSwitch-switchBase": {
            color: theme.palette.error.main, // Use theme color for off state
          },
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: theme.palette.success.main, // Use theme color when checked
          },
          "& .MuiSwitch-switchBase + .MuiSwitch-track": {
            backgroundColor: theme.palette.error.main, // Track color for off state
          },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: theme.palette.success.main, // Track color when checked
          },
        }}
      />
    );
  }, [control, handleToggleButtonChange]);
  
  const columnsItem: Column[] = useMemo(() => {
    let columnArray: Column[] = [
      { id: "sku", label: "SKU", minWidth: 100 },
    ]
    columnArray.push(
      { id :"hcpcsCode", label: "HCPCS Code", minWidth: 100},
      { id: "size", label: "Size", minWidth: 100},
      { id: "units", label: "# of Units", minWidth: 100},
      { id :"productItemDescription", label: "Description", minWidth: 100}
    );
    //CS-1187 - Start && //CS-1248 - Changing the product category to use the constant
    if(selectedProductCategory === PRODUCT_CATEGORY.CONSERVATIVE && getValues("isKit") === true) {
      columnArray.push({ id: "noOfDays", label: "Days", minWidth: 100});
    }
    //CS-1187 - End
    if (canEditProduct && editForm) {
      columnArray.push({ id: "isSizeActive", label: "Availability", minWidth: 100});
       
     }
    columnArray.push({ id: "usageType", label: "Usage Type", width: 50});
    
    if (canEditProduct || !editForm) {
      columnArray.push({ id: "action", label: "Action", minWidth: 100, align: "right"});
    }
    return columnArray;
  }, [canEditProduct, editForm ,selectedProductCategory,getValues("isKit")]);    

  const columnsItemPrices: Column[] = useMemo(() => {
    let columnArray: Column[] = [
      { id: "sku", label: "SKU", minWidth: 100 },
    ]
    columnArray.push(
      { id: "hcpcsCode", label: "HCPCS Code", minWidth: 100 },
      { id: "size", label: "Size", minWidth: 100 },
      { id: "units", label: "# of Units", minWidth: 100 },
      { id: "productItemDescription", label: "Description", minWidth: 100 }
    );
    //CS-1187 - Start && //CS-1248 - Changing the product category to use the constant
    if (selectedProductCategory === PRODUCT_CATEGORY.CONSERVATIVE && getValues("isKit") === true) {
      columnArray.push({ id: "noOfDays", label: "Days", minWidth: 100 });
    }
    //CS-1187 - End
    columnArray.push(
      { id: "listPrice", label: "List Price", minWidth: 100 },
      { id: "allowableUnitPrice", label: "Allowable", minWidth: 100 },
      { id: "customPrice", label: "Custom Price", minWidth: 100},
    );
    columnArray.push(
      { id: "effectiveDate", label: "Effective Date", minWidth: 100 }
    );

    if (canEditProduct && editForm) {
      columnArray.push({ id: "isSizeActive", label: "Availability", minWidth: 100});
       
     }

     if (editForm) {
      columnArray.push({ id: "usageType", label: "Usage Type", minWidth: 100 },);
    }
    if (canEditProduct || !editForm) {
      columnArray.push({ id: "action", label: "Action", minWidth: 100, align: "right"});
    }
    return columnArray;
  }, [canEditProduct, editForm ,selectedProductCategory ,getValues("isKit")]); 
//CS-1378 - Alignment changes
  // Show the "Inactive Date" column only when at least one current/future record
  // actually has an inactive date set. History popups continue to show it for all rows.
  const showPriceInactiveDate = useMemo(() => {
    return (productPriceRows || []).some((row: any) =>
      row?.inactiveDate && row.inactiveDate !== "-" && row.inactiveDate !== "N/A"
    );
  }, [productPriceRows]);

  const showTemplateInactiveDate = useMemo(() => {
    return (productDocumentInfo || []).some((pd: any) =>
      pd?.entityName === "Template" &&
      pd?.inactiveDate && pd.inactiveDate !== "-" && pd.inactiveDate !== "N/A"
    );
  }, [productDocumentInfo]);

  const showDocumentInactiveDate = useMemo(() => {
    return (productDocumentInfo || []).some((pd: any) =>
      pd?.entityName === "Document" && pd?.docName !== null &&
      pd?.inactiveDate && pd.inactiveDate !== "-" && pd.inactiveDate !== "N/A"
    );
  }, [productDocumentInfo]);

  const columnsPriceItem: Column[] = useMemo(() => {
    let columnArray: Column[] = [
      { id: "effectiveDate", label: "Effective Date", minWidth: 100  },
    ]
    columnArray.push(
      { id: "priceType", label: "File Type", minWidth: 100 },
      { id: "listPrice", label: "List Price", minWidth: 100},
      { id: "allowableUnitPrice", label: "Allowable", minWidth: 100}
    );
    // discounts?.map((discount) => {
    //   columnArray.push({ id: discount.displayValue, label: discount.displayValue, minWidth: 100, align: "right" });
    // });
    columnArray.push({ id: "customPrice", label: "Custom Price", minWidth: 100});
    if (canManageTierPrice) {
      columnArray.push({ id: "tierPrice", label: "Tier Price", minWidth: 100});
    }
    if (editForm && showPriceInactiveDate) {
      columnArray.push({ id: "inactiveDate", label: "Inactive Date", minWidth: 100});
    }
    if (canEditProduct || !editForm) {
      columnArray.push({ id: "action", label: "Action", minWidth: 100});
    }
    return columnArray;
  }, [discounts, editForm, showPriceInactiveDate, canManageTierPrice]);
//CS-1378 - End
  const columnsTemplateDocs: Column[] = useMemo(() => {
    let columnArray: Column[] = [
      { id: "type", label: "Type", minWidth: 80 },
      { id: "docName", label: "Name", minWidth: 100 },
      { id: "description", label: "Description", minWidth: 120 },
      // { id: "status", label: "Status", minWidth: 120 },
    ];
    if (showTemplateInactiveDate) {
      columnArray.push({ id: "inactiveDate", label: "Inactive Date", minWidth: 100 });
    }
    columnArray.push({ id: "action", label: "Download", minWidth: 80 });
    return columnArray;
  }, [editForm, showTemplateInactiveDate]);

  useEffect(() => {
    if (allCodeTableValueFetchStatus === "success" && allCodeTablesValuesMap) {
      const sortedProductCategoryList = [
        ...getCodeTableValuesByTableName(allCodeTablesValuesMap, PRODUCT_CATEGORY_CODETABLE),
      ].sort((a, b) => a.displayValue.localeCompare(b.displayValue));
      setProductCategories(sortedProductCategoryList);
    }
  }, [allCodeTablesValuesMap, allCodeTableValueFetchStatus]);

  const statusOptions = useMemo(() => {
    let options: { label: string, value: any }[] = [
      { value: "ACTIVE", label: "ACTIVE" },
      { value: "INACTIVE", label: "INACTIVE" },
      { value: "TBD", label: "TBD" },
      { value: "INPROGRESS", label: "IN PROGRESS" },
    ];
    return options;
  }, []);

  const productCategoryOptions = useMemo(() => {
    return productCategories.map(item => ({
      label: item.displayValue,
      value: item.keyName
    }));
  }, [productCategories]);

  useEffect(() => {
    let productItems = getValues("productItems") || [];
    const formattedProductRows = productItems.map(prev => {
      return {
        ...prev,
        isSizeActive : prev.isSizeActive === null ? true : prev.isSizeActive
      }
    });

    const sortedProductRows = formattedProductRows.sort((a, b) => {
      return Number(a.units) - Number(b.units);
    });

    if(JSON.stringify(productItems) !== JSON.stringify(sortedProductRows)) {
      setValue('productItems', sortedProductRows);
    }
  }, [watch('productItems')]);

  
  const columnsDocuments: Column[] = [
    { id: "documentType", label: "Type", minWidth: 100 },
    { id: "docName", label: "Name", minWidth: 150 },
    { id: "manufacturer", label: "Manufacturer", minWidth: 100 },
    { id: "status", label: "Status", minWidth: 100 },
    { id: "effectiveDate", label: "Effective Date", minWidth: 75 },
    ...(showDocumentInactiveDate ? [{ id: "inactiveDate", label: "Inactive Date", minWidth: 75 }] : []),
    // { id: "fileName", label: "File Name", minWidth: 100 },
    { id: "comments", label: "Comment", minWidth: 75 },
    // { id: "updatedTime", label: "Updated Time", minWidth: 100, align: "center" },
    { id: "documentURL", label: "Document URL", minWidth: 150, },
    { id: "action", label: "Action" }
  ];

  
  const commentComponent = useCallback((row: any) => {
    return (<>
      <Grid item>
        {
          row.comments ?
            <CustomCommentPreview
              title={`Comment`}
              commentBody={row.comments}
            /> : "N/A"}
      </Grid>
    </>)
  }, [productDocumentInfo]);

  const URLComponent = useCallback((row: any) => {
    const url = typeof row.documentURL === "string" ? row.documentURL : null;
  
    if (!url) {
      return null;
    }
  
    return (
      <>
        <Grid>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline", color: colors.info[300] }}
          >
            {url.length > 30 ? `${url.substring(0, 30)}...` : url}
          </a>
        </Grid>
      </>
    );
  }, [colors.info]);
  

  const onDocInactiveClick = useCallback((row: ProductDocumentListInfo) => {
    const manufacturerId = row.manufacturer?.manufacturerId ?? null;
    setShowDocInactivePopup({
      isShow: true,
      productId: row.productId ?? 0,
      manufacturerId: row.productId ? null : manufacturerId,
      documentId: row.entityId
    });
  },[productDocumentInfo]);

  const submitDocInactiveDate = (date: string) => {
    dispatch(inactiveProductDocument({inactiveRequest: {
      productId: showDocInactivePopup?.manufacturerId ? null : showDocInactivePopup?.productId,
      manufacturerId: showDocInactivePopup?.manufacturerId,
      documentId: showDocInactivePopup?.documentId,
      inactiveDate: date
    }}))
  };

  const productDocumentStatusOpts = [ 
    {label: PRODUCT_DOCUMENT_STATUS.PENDING, value: PRODUCT_DOCUMENT_STATUS.PENDING},
    {label: PRODUCT_DOCUMENT_STATUS.FEEDBACK, value: PRODUCT_DOCUMENT_STATUS.FEEDBACK}, 
    {label:PRODUCT_DOCUMENT_STATUS.DEV, value: PRODUCT_DOCUMENT_STATUS.DEV},
    {label:PRODUCT_DOCUMENT_STATUS.STAGE, value: PRODUCT_DOCUMENT_STATUS.STAGE},
    {label:PRODUCT_DOCUMENT_STATUS.LIVE, value: PRODUCT_DOCUMENT_STATUS.LIVE},
    {label:PRODUCT_DOCUMENT_STATUS.INACTIVE, value: PRODUCT_DOCUMENT_STATUS.INACTIVE},
  ];

  useEffect(() => {
    if (allCodeTableValueFetchStatus === "success" && allCodeTablesValuesMap) {
      const sortedDocumentList = [
        ...getCodeTableValuesByTableName(allCodeTablesValuesMap, "ProductDocument"),
      ].sort((a, b) => a.displayValue.localeCompare(b.displayValue));
      const productDocumentTypeMap = Object.fromEntries(
        sortedDocumentList.map(item => [item.keyName, item.displayValue])
      );
      setProductDocumentTypeMap(productDocumentTypeMap)
    }
  }, [allCodeTablesValuesMap, allCodeTableValueFetchStatus]);

  const renderStatusComponent = (status: string, entityId: number) => {
    if (canChangeProductDocumentStatus && isEditing && status) {
      return (
        <>
          <CustomDropdownField
            name={`productDocumentStatus.status${entityId}`}
            control={control}
            onChangeSelect={(data) => {
              const inputData = data?.value;
              if (inputData !== statusData.status) {
                setStatusData({ ...statusData, status: inputData, manufacturerId: productManufacturerId, documentType: productDocumentType, docName: productDocumentName });
                setUpdateStatusPopup(true);
              }
            }}
            options={productDocumentStatusOpts || []}
          />
        </>
      );
    } else {
      return status;
    }
  };

  const productTemplateRows: ProductDocumentListInfo[] = useMemo(() => {
    const rows: ProductDocumentListInfo[] = [];
    productDocumentInfo?.forEach(pd => {
      if (pd.entityName === 'Template') {
        const row = {
          ...pd,
          inactiveDate: pd.inactiveDate || "-",
        }
        rows.push(row)
      }
    })
    return rows;
  }, [productDocumentInfo]);

  const statusUpdateDocumentTypes = [
    PRODUCT_DOCUMENT_TYPES.IVR_FORM,
     PRODUCT_DOCUMENT_TYPES.ORDER_FORM, 
     PRODUCT_DOCUMENT_TYPES.SERVICE_AGREEMENT, 
     PRODUCT_DOCUMENT_TYPES.TISSUE_TRACKING_FORM, 
     PRODUCT_DOCUMENT_TYPES.RETURN_FORM
    ];

  const productDocumentRows: any[] = useMemo(() => {
    const rows: any[] = []
    productDocumentInfo?.forEach(pd => {
      if (pd.entityName === 'Document' && pd.docName !== null) {
        const row = {
          ...pd,
          inactiveDate: pd.inactiveDate || "-",
          documentType: productDocumentTypeMap[pd.documentType],
          documentURL: URLComponent(pd),
          comments: commentComponent(pd),
          manufacturer: pd.manufacturer?.manufacturerName || "",
          status: statusUpdateDocumentTypes.includes(pd.documentType) ?
          (  
            statusData.documentId === pd.entityId ?
            (pd.status && renderStatusComponent((pd.status).toString(), parseInt(pd.entityId))) :
            (
              <span
                onClick={() => {
                  //@ts-ignore
                  setValue(`productDocumentStatus.status${pd.entityId}`, pd.status)
                  setStatusData({
                    productId: pd.productId,
                    documentId: pd.entityId, 
                    status: pd.status && (pd.status).toString(), 
                    manufacturerId: pd.manufacturer?.manufacturerId,
                    documentType: pd.documentType,
                    docName: pd.docName
                  });
                  setIsEditing(true); 
                  setOriginalStatusValue(pd.status);
                  setProductManufacturerId(pd.manufacturer?.manufacturerId);
                  setProductDocumentType(pd.documentType);
                  setProductDocumentName(pd.docName);
                }}
                style={{ cursor: "pointer", display: "inline-block" }}
              >
                {pd.status && (pd.status).toString()}
              </span>
            )
          ) : <span>{pd.status && (pd.status).toString()}</span>
        }
        rows.push(row);
      }
    })
    return rows;
  }, [URLComponent, commentComponent, productDocumentInfo]);

 
  
  return (
    <>
    {showProductItemPopup && <ProductItemPopup
        open={showProductItemPopup}
        onClose={() => { setShowProductItemPopup(false); setTableRowIndex(null); setEditItem(false) }}
        addProductItem={addProductItem}
        productItemDetails={productItemObject}
        isEdit={editItem}
        isKitChecked={getValues("isKit")}
        productHcpcsCodeAvailable={getValues("hcpcsCode")?true:false}
        manufacturerCartOption={selectedManufacturer?.cartOption}
      />}

      {/* {showProductItemPopup && getValues("hasSKUPrice") && <ProductItemsPricesPopup
        open={showProductItemPopup}
        onClose={() => { setShowProductItemPopup(false); setTableRowIndex(null); setEditItem(false) }}
        addProductItem={addProductItem}
        productItemDetails={productItemObject}
        isEdit={editItem}
      />} */}

      {showProductItemsPricePopup && <ProductItemsPricePopup
        open={showProductItemsPricePopup}
        onClose={() => { closeItemsPricingPopup(); }}
        addProductItemsPrice={addProductItemsPrice}
        productItemPriceObject={priceItemsObject}
        editPricing={editItem}
        editProduct={editForm}
        rowIndex={tableRowIndex}
        inactiveOnly={inactiveOnly}
        productItemPriceList={getValues("productPrices")}
        productItemsList={getValues('productItems')}
      />}

      { showProductItemPricePopup && <ProductItemPricePricePopup
        open={showProductItemPricePopup}
        onClose={() => {closePricingPopup();}}
        addProductItemPrice={addProductItemPrice}
        productItemPriceObject={priceItemObject}
        editPricing={editItem}
        editProduct={editForm}
        rowIndex={tableRowIndex}
        inactiveOnly={inactiveOnly}
        productItemPriceList = {getValues("productPrices")}
        canManageTierPrice={canManageTierPrice}
      /> }
      {canManageTierPrice && <>
      <Dialog
        open={!!tierPriceTarget}
        onClose={() => setTierPriceTarget(null)}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
        scroll="paper"
        PaperProps={{ sx: paperSx(isMobile) }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden" }}>
          <Box sx={headerSx}>
            <Box sx={iconBoxSx(modalTokens.accent)}>
              <AttachMoneyOutlined sx={{ fontSize: "1rem", color: modalTokens.accent }} />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography fontWeight={700} sx={{ fontSize: "1rem", color: modalTokens.textPrimary, lineHeight: 1.3 }}>
                Tier Price
              </Typography>
            </Box>
            <IconButton onClick={() => setTierPriceTarget(null)} size="small" sx={closeIconSx}>
              <CloseIcon sx={{ fontSize: "1rem" }} />
            </IconButton>
          </Box>
          <Box sx={{ ...bodySx, flex: "0 0 auto", px: 4, py: 3, minHeight: 0, overflowY: "auto" }}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1.5 }}>
              {viewTierRows.length < tierKeys.length && (
                <Button
                  type="button"
                  startIcon={<AddCircleOutlineOutlined />}
                  onClick={() => openViewTierEditor()}
                  variant="outlined"
                  removeUpperCase
                >
                  Add Tier Price
                </Button>
              )}
              </Box>
            <Box sx={scrollAreaSx({ maxHeight: 168, gap: 0 })}>
            <CustomTable
              columns={[
                { id: "tierLabel", label: "Tier", minWidth: 120 },
                { id: "price", label: "Price", minWidth: 100 },
                { id: "action", label: "Actions", minWidth: 90 },
              ]}
              rows={viewTierRows.map((row) => ({ ...row, tierLabel: tierLabel(row.tier) }))}
              disablePagination
              borderBox={false}
              showMenu={false}
              emptyText="No Tier Price(s) Found"
              actionComponent={(row: { tier: string; tierLabel?: string }) => (
                <Box sx={{ display: "flex", gap: 1 }}>
                  <CustomIconButton
                    color="error"
                    size="small"
                    variant="outlined"
                    tooltipMessage="Delete"
                    tooltipPlacement="top"
                    aria-label={`Delete ${row.tierLabel || row.tier}`}
                    onClick={() => deleteViewTierRow(row.tier)}
                  >
                    <DeleteOutlineOutlined fontSize="small" />
                  </CustomIconButton>
                </Box>
              )}
            />
            </Box>
          </Box>
          <Box sx={footerSx}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
              <Button
                sx={{ ...cancelBtnSx, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 0.8, px: 3, py: 1.2, border: "1px solid", cursor: "pointer" }}
                onClick={() => setTierPriceTarget(null)}
                startIcon={<Cancel />}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>
      <Dialog
        open={showViewTierEditor}
        onClose={() => setShowViewTierEditor(false)}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{ sx: paperSx(isMobile) }}
      >
        <Box sx={headerSx}>
          <Box sx={{ flex: 1, pr: 4 }}>
            <Typography fontWeight={700} sx={{ fontSize: "1.1rem", color: modalTokens.textPrimary }}>
              Add Tier Price
            </Typography>
            <Typography sx={{ fontSize: "0.8rem", color: modalTokens.textSecondary, mt: 0.15 }}>
              Select the tier and enter its price.
            </Typography>
          </Box>
          <IconButton onClick={() => setShowViewTierEditor(false)} size="small" aria-label="Close tier price" sx={closeIconSx}>
            <CloseIcon sx={{ fontSize: "1rem" }} />
          </IconButton>
        </Box>
        <Box sx={bodySx}>
          <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
              <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: modalTokens.textSecondary, mb: 0.7 }}>Tier</Typography>
              <Box sx={dropdownWrapSx(!!viewTierForm.formState.errors.tier)}>
                <CustomDropdownField
                  label=""
                  name="tier"
                  options={viewTierOptions}
                  control={viewTierForm.control}
                  size="small"
                  rules={{ required: "Tier is required." }}
                />
              </Box>
            </Grid>
            <Grid item md={6} xs={12}>
              <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: modalTokens.textSecondary, mb: 0.7 }}>Price</Typography>
              <Box sx={inputFieldSx(!!viewTierForm.formState.errors.price)}>
                <CustomTextField
                  control={viewTierForm.control}
                  controllerName="price"
                  label=""
                  size="small"
                  rules={{ required: "Price is required." }}
                />
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ ...footerSx, display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 2 }}>
            <Button type="button" onClick={viewTierForm.handleSubmit(saveViewTierRow)} startIcon={<ModeOutlined />}>
              Add
            </Button>
            <Button type="button" color="secondary" onClick={() => setShowViewTierEditor(false)} startIcon={<Cancel />}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Dialog>
      </>}
      <ProductItemHistoryPopup
        open={showProductItemHistoryPopup}
        onClose={() => setShowProductItemHistoryPopup(false)}
      />
      <ProductItemSKULevelPriceHistoryPopup
        open={showProductItemSKULevelHistoryPopup}
        onClose={() => setShowProductItemSKULevelHistoryPopup(false)}
      />
      {showProductAgreementPopup&&(<>
      <ProductAgreementPopup
        open={showProductAgreementPopup}
        onClose={() => {
          setShowProductAgreementPopup(false);
          // Refresh pricing table + history without a full page reload (keeps current tab).
          dispatch(updateElementInProductSlice({
            elementName: "saveProductPriceStatus",
            value: "idle",
          }));
          const productId = productObject?.productId;
          if (productId > 0) {
            dispatch(getProduct({ productId }));
            dispatch(getProductPricingHistory({ productId }));
          }
        }}
      />
      </>)}
      {/* CS-1760 - Product Config is rendered inline in the Config tab */}
      <ProductItemPriceHistoryPopup
        open={showProductItemPriceHistoryPopup}
        onClose={() => setShowProductItemPriceHistoryPopup(false)}
      />
      {showProductDocumentHistoryPopup &&
        <ProductDocumentHistory
          open={showProductDocumentHistoryPopup}
          onClose={() => {setProductDocumentHistoryPopup(false)}}
        />
      }


{showProductItemKitPopup && (
  <AddProductKitPopup
    open={showProductItemKitPopup
    }
    onClose={() => { 
      setShowProductItemkitPopup(false); 
      setTableRowIndex(null); 
      setEditItem(false);
    }}
    productItemkitDetails={productItemkitObject} 
    isEdit={editItem} 
    rowData={rowData} 
    selectedProductManufacture={selectedManufacture}
  />
)}


      <Box mx={2} mb={5} mt={2}>
        <Stack direction="row" alignItems="center" spacing={1.25} mb={1}>
          <IconButton
            onClick={() => navigate(-1)}
            aria-label="Back"
            sx={{
              border: `1px solid ${modalTokens.border}`,
              borderRadius: "10px",
              color: modalTokens.textSecondary,
              "&:hover": { color: modalTokens.accent, borderColor: modalTokens.accent, backgroundColor: modalTokens.inputBg },
            }}
          >
            <ArrowBackOutlined fontSize="small" />
          </IconButton>
          <Header
            title="Product Management"
            subtitle="Create and configure your product across all sections."
          />
        </Stack>

        <ProductTabNav
          tabs={productTabs}
          activeTab={activeTab}
          onTabChange={(tabId) => setActiveTab(tabId as ProductTabId)}
        />

        {(safeProductName || showOrderButton || showRequestRxButton) && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 1.5,
              mb: 2,
            }}
          >
            {safeProductName ? (
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 1.5,
                  py: 0.75,
                  borderRadius: "999px",
                  border: `1px solid ${modalTokens.accent}40`,
                  backgroundColor: `${modalTokens.accent}0f`,
                }}
              >
                <Inventory2Outlined sx={{ fontSize: 15, color: modalTokens.accent }} />
                <Typography sx={{ fontSize: "0.85rem", fontWeight: 700, color: modalTokens.textPrimary, lineHeight: 1 }}>
                  {safeProductName}
                </Typography>
                {selectedManufacturer?.manufacturerName && (
                  <>
                    <Box sx={{ width: 3, height: 3, borderRadius: "50%", backgroundColor: modalTokens.textSecondary, flexShrink: 0 }} />
                    <Typography sx={{ fontSize: "0.8rem", fontWeight: 500, color: modalTokens.textSecondary, lineHeight: 1 }}>
                      {selectedManufacturer.manufacturerName}
                    </Typography>
                  </>
                )}
              </Box>
            ) : (
              <Box />
            )}

            {showOrderButton && (
              <Button
                variant="contained"
                size="small"
                removeUpperCase
                startIcon={<ShoppingCartOutlined fontSize="small" />}
                onClick={handlePlaceOrderClick}
                sx={{ ...primaryActionBtnSx, py: 0.8, px: 1.6, minHeight: "unset" }}
              >
                Place Order
              </Button>
            )}
            {showRequestRxButton && (
              <Button
                variant="contained"
                size="small"
                removeUpperCase
                startIcon={<AssignmentOutlined fontSize="small" />}
                onClick={handleRecordRxClick}
                sx={{ ...primaryActionBtnSx, py: 0.8, px: 1.6, minHeight: "unset" }}
              >
                Record Rx
              </Button>
            )}
          </Box>
        )}


          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ display: activeTab === "info" ? "block" : "none" }}>
              <Box
                sx={{
                  borderRadius: "12px",
                  border: `1px solid ${modalTokens.border}`,
                  backgroundColor: modalTokens.bg,
                  p: { xs: 2, sm: 2.5 },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2.5 }}>
                  <Box sx={iconBoxSx(modalTokens.accent)}>
                    <Inventory2Outlined sx={{ fontSize: 20, color: modalTokens.accent }} />
                  </Box>
                  <Typography sx={{ fontSize: "1.15rem", fontWeight: 800, color: modalTokens.textPrimary, letterSpacing: "-0.01em" }}>
                    Product Info
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, mb: 2 }}>
                  <Box
                    sx={{
                      display: "inline-flex",
                      flexShrink: 0,
                      width: 150,
                      height: 150,
                      border: `1.5px dashed ${modalTokens.inputBorder}`,
                      borderRadius: "12px",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: modalTokens.inputBg,
                      transition: "border-color 0.2s ease, background-color 0.2s ease",
                      "&:hover": {
                        borderColor: modalTokens.accent,
                      },
                      "& .MuiSvgIcon-root": { color: modalTokens.accent },
                    }}
                  >
                    <FileUploader
                      name="productLogo"
                      label={
                        <>
                          Upload Your Logo
                          <br />
                          <Box component="span" sx={{ color: modalTokens.accent, fontSize: "0.85rem" }}>
                            here in .png format
                          </Box>
                        </>
                      }
                      onFileChange={() => { }}
                      onFileChangeTest={handleDropzoneChange}
                      allowedFileTypes={png}
                      document={productObject?.documents?.[0]}
                      optionPopupObject={editForm ? (productObject?.documents?.[0] ? { show: true, message: "Do you really want to change the product logo?" }
                        : { show: true, message: "Do you really want to save the product logo?" }) : undefined}
                      disableActions={!(canEditProduct || !editForm)}
                    />
                  </Box>

                  <Box
                    sx={{
                      flex: 1,
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
                      gap: 2,
                      alignContent: "start",
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: modalTokens.textSecondary, mb: 0.7, display: "flex", alignItems: "center", gap: 0.3 }}>
                        Product Name
                        <Box component="span" sx={{ color: modalTokens.accent }}>*</Box>
                      </Typography>
                      <CustomTextField
                        label=""
                        controllerName="productName"
                        control={control}
                        rules={{ required: "Product Name is required." }}
                        disabled={!(canEditProduct || !editForm)}
                        size="small"
                        placeholder="Product Name"
                        sx={inputFieldSx(!!errors.productName)}
                      />
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: modalTokens.textSecondary, mb: 0.7 }}>
                        HCPCS Code
                      </Typography>
                      <CustomTextField
                        label=""
                        controllerName="hcpcsCode"
                        control={control}
                        disabled={!(canEditProduct || !editForm)}
                        size="small"
                        placeholder="HCPCS Code"
                        sx={inputFieldSx(!!errors.hcpcsCode)}
                      />
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: modalTokens.textSecondary, mb: 0.7 }}>
                        Composition
                      </Typography>
                      <CustomTextField
                        label=""
                        controllerName="composition"
                        control={control}
                        disabled={!(canEditProduct || !editForm)}
                        size="small"
                        placeholder="Composition"
                        sx={inputFieldSx(!!errors.composition)}
                      />
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: modalTokens.textSecondary, mb: 0.7 }}>
                        Insurance Coverage
                      </Typography>
                      <CustomTextField
                        label=""
                        controllerName="insuranceCoverage"
                        control={control}
                        disabled={!(canEditProduct || !editForm)}
                        size="small"
                        placeholder="Insurance Coverage"
                        sx={inputFieldSx(!!errors.insuranceCoverage)}
                      />
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" },
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: modalTokens.textSecondary, mb: 0.7, display: "flex", alignItems: "center", gap: 0.3 }}>
                      MUEs
                      <Box component="span" sx={{ color: modalTokens.accent }}>*</Box>
                    </Typography>
                    <CustomTextField
                      label=""
                      controllerName="mues"
                      control={control}
                      rules={{ required: "MUEs is required." }}
                      disabled={!(canEditProduct || !editForm)}
                      size="small"
                      placeholder="MUEs"
                      sx={inputFieldSx(!!errors.mues)}
                    />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: modalTokens.textSecondary, mb: 0.7, display: "flex", alignItems: "center", gap: 0.3 }}>
                      Manufacturer
                      <Box component="span" sx={{ color: modalTokens.accent }}>*</Box>
                    </Typography>
                    <Box sx={dropdownWrapSx(!!errors.manufacturerId)}>
                      <CustomDropdownField
                        label=""
                        name="manufacturerId"
                        disabled={!(canEditProduct || !editForm)}
                        options={manufacturersList}
                        control={control}
                        rules={{ required: "Manufacturer is required." }}
                        size="small"
                        placeholderText="Manufacturer"
                      />
                    </Box>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: modalTokens.textSecondary, mb: 0.7, display: "flex", alignItems: "center", gap: 0.3 }}>
                      Product Category
                      <Box component="span" sx={{ color: modalTokens.accent }}>*</Box>
                    </Typography>
                    <Box sx={dropdownWrapSx(!!errors.productCategory)}>
                      <CustomDropdownField
                        name="productCategory"
                        control={control}
                        label=""
                        options={productCategoryOptions}
                        disabled={!canEditProduct}
                        rules={{ required: "Product Category is required." }}
                        size="small"
                        placeholderText="Product Category"
                      />
                    </Box>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: modalTokens.textSecondary, mb: 0.7, display: "flex", alignItems: "center", gap: 0.3 }}>
                      Status
                      <Box component="span" sx={{ color: modalTokens.accent }}>*</Box>
                    </Typography>
                    <Box sx={dropdownWrapSx(!!errors.productStatus)}>
                      <CustomDropdownField
                        name="productStatus"
                        control={control}
                        label=""
                        options={statusOptions}
                        disabled={!canEditProduct}
                        rules={{ required: "Status is required." }}
                        size="small"
                        placeholderText="Status"
                      />
                    </Box>
                  </Box>
                <Box>
                  <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: modalTokens.textSecondary, mb: 0.7 }}>
                    Compound Type
                  </Typography>
                  <Box sx={dropdownWrapSx(false)}>
                    <CustomDropdownField
                      name="compoundType"
                      control={control}
                      label=""
                      options={compoundTypeOptions}
                      disabled={!(canEditProduct || !editForm)}
                      size="small"
                      placeholderText="Select Compound Type"
                    />
                  </Box>
                </Box>
                  <Box sx={{ gridColumn: { xs: "1", md: "1 / -1" } }}>
                    <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: modalTokens.textSecondary, mb: 0.7 }}>
                      Product Description
                    </Typography>
                    <CustomTextField
                      label=""
                      controllerName="productDescription"
                      control={control}
                      disabled={!(canEditProduct || !editForm)}
                      size="small"
                      placeholder="Product Description"
                      multiline
                      minRows={3}
                      sx={inputFieldSx(!!errors.productDescription)}
                    />
                  </Box>
                </Box>

                {canAccessHasSKUToggleButton && (
                  <Box
                    sx={{
                      mt: 2.5,
                      p: 2,
                      borderRadius: "10px",
                      border: `1px solid ${modalTokens.border}`,
                      backgroundColor: modalTokens.inputBg,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                      flexWrap: "wrap",
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontWeight: 600, fontSize: "0.9rem", color: modalTokens.textPrimary }}>Has SKU Price</Typography>
                      <Typography sx={{ fontSize: "0.8rem", color: modalTokens.textSecondary, mt: 0.25 }}>
                        Toggle to enable per-SKU pricing overrides.
                      </Typography>
                    </Box>
                    <Controller name={"hasSKUPrice"} control={control}
                      render={({ field }) => (
                        <CustomTooltip
                          title={HAS_SKU_PRICE_LOCKED_MESSAGE}
                          arrow
                          placement="top"
                          disableHoverListener={!isHasSKUPriceLockedByPricing}
                          disableFocusListener={!isHasSKUPriceLockedByPricing}
                        >
                          <Box component="span" sx={{ display: "inline-flex" }} data-testid="has-sku-price-toggle">
                            <FormControlLabel
                              control={
                                <SwitchTextTrack
                                  {...field}
                                  name={field.name}
                                  checked={!!field.value}
                                  size="medium"
                                  disabled={isHasSKUPriceDisabled}
                                  inputProps={{ "aria-label": "Has SKU Price" }}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    if (!editForm) {
                                      setValue("productItems", []);
                                      setProductItemRows(generateProductItemsRows(([])));
                                    }
                                  }}
                                />
                              }
                              disabled={isHasSKUPriceDisabled}
                              label=""
                              labelPlacement="start"
                              sx={{ m: 0 }}
                            />
                          </Box>
                        </CustomTooltip>
                      )}
                    />
                  </Box>
                )}

                {selectedProductCategorys === PRODUCT_CATEGORY.CONSERVATIVE && (
                  <Box
                    sx={{
                      mt: 1.5,
                      p: 2,
                      borderRadius: "10px",
                      border: `1px solid ${modalTokens.border}`,
                      backgroundColor: modalTokens.inputBg,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                      flexWrap: "wrap",
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontWeight: 600, fontSize: "0.9rem", color: modalTokens.textPrimary }}>Is Kit</Typography>
                      <Typography sx={{ fontSize: "0.8rem", color: modalTokens.textSecondary, mt: 0.25 }}>
                        Enable kit configuration for conservative care products.
                      </Typography>
                    </Box>
                    <Controller
                      name="isKit"
                      control={control}
                      render={({ field }) => (
                        <FormControlLabel
                          control={
                            <SwitchTextTrack
                              {...field}
                              name={field.name}
                              checked={field.value}
                              size="medium"
                              disabled={!(canEditProduct || !editForm) || editForm}
                              onChange={(e) => {
                                field.onChange(e.target.checked);
                              }}
                            />
                          }
                          disabled={editForm}
                          label=""
                          labelPlacement="start"
                          sx={{ m: 0 }}
                        />
                      )}
                    />
                  </Box>
                )}

                {shouldShowCompoundedNotice && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 2,
                      mt: 2,
                      mb: 1,
                      p: 2,
                      borderRadius: "10px",
                      border: `1px solid ${theme.palette.mode === "dark" ? "rgba(20,184,166,0.28)" : "rgba(20,184,166,0.4)"}`,
                      backgroundColor: theme.palette.mode === "dark" ? "rgba(20,184,166,0.06)" : "rgba(20,184,166,0.05)",
                      position: "relative",
                    }}
                  >
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "8px",
                        backgroundColor: theme.palette.mode === "dark" ? "rgba(20,184,166,0.18)" : "rgba(20,184,166,0.14)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        mt: 0.25,
                      }}
                    >
                      <InfoOutlined sx={{ color: "#14b8a6", fontSize: "1.3rem" }} />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0, pr: 3 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: "0.95rem", mb: 0.5 }}>
                        Compounded Medication Notice
                      </Typography>
                      <Typography sx={{ fontSize: "0.85rem", color: colors.grey[400], lineHeight: 1.65}}>
                        {`The medications available through this integration are compounded by ${pharmacyDisplayName}, a licensed 503A compounding pharmacy. Compounded medications are not FDA-approved. They are prepared for an identified individual patient based on a valid prescription from a licensed provider.`}
                      </Typography>
                    </Box>
                    <IconButton
                      size="small"
                      onClick={() => setShowGlpNotice(false)}
                      aria-label="Dismiss notice"
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        color: "#14b8a6",
                        "&:hover": { color: "#14b8a6", backgroundColor: "rgba(20,184,166,0.1)" },
                      }}
                    >
                      <CloseIcon sx={{ fontSize: "1rem" }} />
                    </IconButton>
                  </Box>
                )}

                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 3 }}>
                  {canEditProduct && editForm && (
                    <MuiButton
                      type="button"
                      variant="contained"
                      disableElevation
                      onClick={updateProductValues}
                      startIcon={<Upgrade sx={{ fontSize: "1rem !important" }} />}
                      sx={primaryBtnSx}
                    >
                      Update Product
                    </MuiButton>
                  )}
                  {!editForm && (
                    <MuiButton
                      variant="contained"
                      disableElevation
                      type="submit"
                      startIcon={<SaveOutlined sx={{ fontSize: "1rem !important" }} />}
                      sx={primaryBtnSx}
                    >
                      Save Product
                    </MuiButton>
                  )}
                  {cancelButton}
                </Box>
              </Box>
            </Box>

            {canEditProductConfig && (
              <Box sx={{ display: activeTab === "config" ? "block" : "none" }}>
                <ProductConfigPopup
                  embedded
                  open={activeTab === "config"}
                  onClose={() => setActiveTab("info")}
                  productId={productObject.productId}
                  canEdit={canEditProduct || !editForm}
                  isDraftMode={!editForm}
                  initialConfigRules={draftProductConfigRules}
                  onDraftSave={(configRules) => setDraftProductConfigRules(configRules)}
                  onSaveSuccess={(configRules) => {
                    setSavedProductConfigRules(configRules);
                    setActiveTab("catalog");
                  }}
                  productName={safeProductName || undefined}
                />
              </Box>
            )}

            <Box sx={{ display: activeTab === "catalog" ? "block" : "none" }}>
              <Box
                sx={{
                  borderRadius: "12px",
                  border: `1px solid ${modalTokens.border}`,
                  backgroundColor: modalTokens.bg,
                  p: { xs: 2, sm: 2.5 },
                }}
              >
                <Grid container spacing={2} alignItems="center" mb={2}>
                  <Grid item xs={12} md={4} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Box sx={iconBoxSx(modalTokens.accent)}>
                      <HubOutlined sx={{ fontSize: 20, color: modalTokens.accent }} />
                    </Box>
                    <Typography sx={{ fontSize: "1.15rem", fontWeight: 800, color: modalTokens.textPrimary, letterSpacing: "-0.01em" }}>
                      Product Catalog
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={8}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: { xs: "flex-start", md: "flex-end" },
                      flexWrap: "wrap",
                      gap: 1,
                    }}
                  >
                    {(canEditProduct || !editForm) && (
                      <>
                        {/* <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.6, px: 0.75, py: 0.4 }}>
                          <ModeOutlined sx={{ fontSize: 16, color: modalTokens.textPrimary }} />
                          <Typography sx={{ fontSize: "0.78rem", fontWeight: 600, color: modalTokens.textPrimary }}>Edit</Typography>
                        </Box>
                        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.6, px: 0.75, py: 0.4 }}>
                          <DeleteOutlineOutlined sx={{ fontSize: 16, color: "#ef4444" }} />
                          <Typography sx={{ fontSize: "0.78rem", fontWeight: 600, color: "#ef4444" }}>Delete</Typography>
                        </Box> */}
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 0.7,
                            px: 1.2,
                            py: 0.5,
                            borderRadius: "999px",
                            border: `1px solid ${modalTokens.border}`,
                            backgroundColor: modalTokens.inputBg,
                          }}
                        >
                          <FiberManualRecord sx={{ fontSize: 9, color: "#ef4444" }} />
                          <Typography sx={{ fontSize: "0.78rem", fontWeight: 600, color: modalTokens.textPrimary }}>Unavailable</Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 0.7,
                            px: 1.2,
                            py: 0.5,
                            borderRadius: "999px",
                            border: `1px solid ${modalTokens.border}`,
                            backgroundColor: modalTokens.inputBg,
                          }}
                        >
                          <FiberManualRecord sx={{ fontSize: 9, color: "#22c55e" }} />
                          <Typography sx={{ fontSize: "0.78rem", fontWeight: 600, color: modalTokens.textPrimary }}>Available</Typography>
                        </Box>
                      </>
                    )}

                    {(canViewProductHistory && editForm) && (
                      <MuiButton
                        type="button"
                        variant="contained"
                        disableElevation
                        startIcon={<Restore sx={{ fontSize: "1rem !important" }} />}
                        onClick={() => setShowProductItemHistoryPopup(true)}
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.82rem",
                          borderRadius: "8px",
                          px: 1.6,
                          py: 0.8,
                          color: "#fff",
                          backgroundColor: "#3b82f6",
                          "&:hover": { backgroundColor: "#2563eb" },
                        }}
                      >
                        Catalog History
                      </MuiButton>
                    )}

                    {(watchedHasSKUPrice && canViewProductHistory && editForm) && (
                      <MuiButton
                        type="button"
                        variant="contained"
                        disableElevation
                        startIcon={<Restore sx={{ fontSize: "1rem !important" }} />}
                        onClick={() => setShowProductItemSKULevelHistoryPopup(true)}
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.82rem",
                          borderRadius: "8px",
                          px: 1.6,
                          py: 0.8,
                          color: "#fff",
                          backgroundColor: "#3b82f6",
                          "&:hover": { backgroundColor: "#2563eb" },
                        }}
                      >
                        SKU Pricing History
                      </MuiButton>
                    )}

                    {(canEditProduct || !editForm) && (
                      <MuiButton
                        type="button"
                        variant="contained"
                        disableElevation
                        startIcon={<AddCircleOutlineOutlined sx={{ fontSize: "1rem !important" }} />}
                        onClick={() => setShowProductItemPopup(true)}
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.82rem",
                          borderRadius: "8px",
                          px: 1.6,
                          py: 0.8,
                          color: "#fff",
                          backgroundColor: "#3b82f6",
                          "&:hover": { backgroundColor: "#2563eb" },
                        }}
                      >
                        Add Item
                      </MuiButton>
                    )}

                    {(watchedHasSKUPrice && (canEditProduct || !editForm)) && (
                      <MuiButton
                        type="button"
                        variant="contained"
                        disableElevation
                        startIcon={<AddCircleOutlineOutlined sx={{ fontSize: "1rem !important" }} />}
                        onClick={openItemsPriceAddingPopup}
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.82rem",
                          borderRadius: "8px",
                          px: 1.6,
                          py: 0.8,
                          color: "#fff",
                          backgroundColor: "#3b82f6",
                          "&:hover": { backgroundColor: "#2563eb" },
                        }}
                      >
                        Add Item Prices
                      </MuiButton>
                    )}
                  </Grid>
                </Grid>

                {watchedHasSKUPrice ? (
                  <CustomTable
                    columns={columnsItemPrices}
                    rows={productItemRows}
                    actionComponent={(row: any, rowIndex: number) => productItemActionComponent(row, rowIndex)}
                    availabilitySwitchComponent={(row: any, rowIndex: number) => toggleAvailabilityButton(row, rowIndex)}
                    disablePagination
                    emptyText="No Product Catalog Item(s) Found"
                    showMenu
                    sx={productTableSx}
                  />
                ) : (
                  <CustomTable
                    columns={columnsItem}
                    rows={getValues("productItems") || []}
                    actionComponent={(row: any, rowIndex: number) => productItemActionComponent(row, rowIndex)}
                    availabilitySwitchComponent={(row: any, rowIndex: number) => toggleAvailabilityButton(row, rowIndex)}
                    disablePagination
                    emptyText="No Product Catalog Item(s) Found"
                    showMenu
                    sx={productTableSx}
                  />
                )}
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 1 }}>
                  {cancelButton}
                </Box>
              </Box>
            </Box>
            
            {!watchedHasSKUPrice && (
            <Box sx={{ display: activeTab === "pricing" ? "block" : "none" }}>
              <Box
                sx={{
                  borderRadius: "12px",
                  border: `1px solid ${modalTokens.border}`,
                  backgroundColor: modalTokens.bg,
                  p: { xs: 2, sm: 2.5 },
                }}
              >
                <Box sx={{ mb: 2.5 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={4} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <Box sx={iconBoxSx(modalTokens.accent)}>
                        <AttachMoneyOutlined sx={{ fontSize: 20, color: modalTokens.accent }} />
                      </Box>
                      <Typography sx={{ fontSize: "1.15rem", fontWeight: 800, color: modalTokens.textPrimary, letterSpacing: "-0.01em" }}>
                        Product Pricing
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={8}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: { xs: "flex-start", md: "flex-end" },
                        flexWrap: "wrap",
                        gap: 1,
                      }}
                    >
                      {/* {(canEditProduct || !editForm) && (
                        <>
                        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.6, px: 0.75, py: 0.4 }}>
                          <DeleteOutlineOutlined sx={{ fontSize: 16, color: "#ef4444" }} />
                          <Typography sx={{ fontSize: "0.78rem", fontWeight: 600, color: "#ef4444" }}>Delete</Typography>
                        </Box>
                        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.6, px: 0.75, py: 0.4 }}>
                          <DoDisturbAltOutlined sx={{ fontSize: 16, color: "#f59e0b" }} />
                          <Typography sx={{ fontSize: "0.78rem", fontWeight: 600, color: "#f59e0b" }}>Inactivate</Typography>
                        </Box>
                      </>
                    )} */}

                    {(canViewProductHistory && editForm) && (
                      <MuiButton
                        type="button"
                        variant="contained"
                        disableElevation
                        startIcon={<Restore sx={{ fontSize: "1rem !important" }} />}
                        onClick={() => setShowProductItemPriceHistoryPopup(true)}
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.82rem",
                          borderRadius: "8px",
                          px: 1.6,
                          py: 0.8,
                          color: "#fff",
                          backgroundColor: "#3b82f6",
                          "&:hover": { backgroundColor: "#2563eb" },
                        }}
                      >
                        Pricing History
                      </MuiButton>
                    )}

                    {(canEditProduct || !editForm) && (
                      <MuiButton
                        type="button"
                        variant="contained"
                        disableElevation
                        startIcon={<AddCircleOutlineOutlined sx={{ fontSize: "1rem !important" }} />}
                        onClick={openPriceAddingPopup}
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.82rem",
                          borderRadius: "8px",
                          px: 1.6,
                          py: 0.8,
                          color: "#fff",
                          backgroundColor: "#3b82f6",
                          "&:hover": { backgroundColor: "#2563eb" },
                        }}
                      >
                        Add Pricing
                      </MuiButton>
                    )}
                    </Grid>
                  </Grid>
                </Box>

                <CustomTable
                  columns={columnsPriceItem}
                  rows={productPriceRows}
                  actionComponent={(row: any, rowIndex: number) => priceItemActionComponent(row, rowIndex)}
                  disablePagination
                  emptyText="No Product Pricing(s) Found"
                  showMenu
                  sx={productTableSx}
                />
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 1 }}>
                  {cancelButton}
                </Box>
              </Box>
            </Box>
            )}

            {isSuperAdmin && isPurchaseAndBillEnabled && (
              <Box sx={{ display: activeTab === "cogs" ? "block" : "none" }}>
                <ProductCogsSection
                  productId={productObject.productId}
                  hasSKUPrice={!!getValues("hasSKUPrice")}
                  productItems={getValues("productItems") || []}
                  isDraftMode={!editForm}
                  draftPurchasePrices={draftProductPurchasePrices}
                  onDraftPurchasePricesChange={setDraftProductPurchasePrices}
                  embedded
                />
              </Box>
            )}

            {canViewProductShipping && (
              <Box sx={{ display: activeTab === "shipping" ? "block" : "none" }}>
                <Box
                  sx={{
                    borderRadius: "12px",
                    border: `1px solid ${modalTokens.border}`,
                    backgroundColor: modalTokens.bg,
                    p: { xs: 2, sm: 2.5 },
                  }}
                >
                  <ProductShippingConfig
                    canEdit={canEditProductShipping && (canEditProduct || !editForm)}
                    productId={productObject.productId}
                    embedded
                    title="Product Shipping"
                    titleIcon={
                      <Box sx={iconBoxSx(modalTokens.accent)}>
                        <LocalShippingOutlined sx={{ fontSize: 20, color: modalTokens.accent }} />
                      </Box>
                    }
                  />
                </Box>
              </Box>
            )}

            <Box sx={{ display: activeTab === "document" ? "block" : "none" }}>
              {editForm && productTemplateRows && productTemplateRows.length > 0 && (
                <Box
                  mb={3}
                  sx={{
                    borderRadius: "12px",
                    border: `1px solid ${modalTokens.border}`,
                    backgroundColor: modalTokens.bg,
                    p: { xs: 2, sm: 2.5 },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2.5 }}>
                    <Box sx={iconBoxSx(modalTokens.accent)}>
                      <DescriptionOutlined sx={{ fontSize: 20, color: modalTokens.accent }} />
                    </Box>
                    <Typography sx={{ fontSize: "1.15rem", fontWeight: 800, color: modalTokens.textPrimary, letterSpacing: "-0.01em" }}>
                      Product Templates
                    </Typography>
                  </Box>
                  <CustomTable
                    columns={columnsTemplateDocs}
                    rows={productTemplateRows || []}
                    actionComponent={(row: any, rowIndex: number) => productTemplateActionComponent(row, rowIndex)}
                    disablePagination
                    showMenu
                    sx={productTableSx}
                  />
                </Box>
              )}

              <Box
                sx={{
                  borderRadius: "12px",
                  border: `1px solid ${modalTokens.border}`,
                  backgroundColor: modalTokens.bg,
                  p: { xs: 2, sm: 2.5 },
                }}
              >
                <Box sx={{ mb: 2.5 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={4} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <Box sx={iconBoxSx(modalTokens.accent)}>
                        <DescriptionOutlined sx={{ fontSize: 20, color: modalTokens.accent }} />
                      </Box>
                      <Typography sx={{ fontSize: "1.15rem", fontWeight: 800, color: modalTokens.textPrimary, letterSpacing: "-0.01em" }}>
                        Product Document
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={8}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: { xs: "flex-start", md: "flex-end" },
                        flexWrap: "wrap",
                        gap: 1,
                      }}
                    >
                      {(canEditProduct || !editForm) && (
                        <>
                      {/* <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.6, px: 0.75, py: 0.4 }}>
                        <DoDisturbAltOutlined sx={{ fontSize: 16, color: "#f59e0b" }} />
                        <Typography sx={{ fontSize: "0.78rem", fontWeight: 600, color: "#f59e0b" }}>Inactivate</Typography>
                      </Box>
                      <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.6, px: 0.75, py: 0.4 }}>
                        <Download sx={{ fontSize: 16, color: modalTokens.accent }} />
                        <Typography sx={{ fontSize: "0.78rem", fontWeight: 600, color: modalTokens.accent }}>Download</Typography>
                      </Box> */}

                      {editForm && (
                        <MuiButton
                          type="button"
                          variant="contained"
                          disableElevation
                          startIcon={<UploadFileOutlined sx={{ fontSize: "1rem !important" }} />}
                          onClick={() => setProductDocumentHistoryPopup(true)}
                          sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "0.82rem",
                            borderRadius: "8px",
                            px: 1.6,
                            py: 0.8,
                            color: "#fff",
                            backgroundColor: "#3b82f6",
                            "&:hover": { backgroundColor: "#2563eb" },
                          }}
                        >
                          Document History
                        </MuiButton>
                      )}

                      {editForm && (
                        <MuiButton
                          type="button"
                          variant="contained"
                          disableElevation
                          startIcon={<UploadFileOutlined sx={{ fontSize: "1rem !important" }} />}
                          onClick={() => setProductDocumentPopupOpen(true)}
                          sx={{
                            ...primaryActionBtnSx,
                            fontSize: "0.82rem",
                            fontWeight: 600,
                            borderRadius: "8px",
                            px: 1.6,
                            py: 0.8,
                            minHeight: "unset",
                          }}
                        >
                          Upload Document
                        </MuiButton>
                      )}
                      </>
                      )}
                    </Grid>
                  </Grid>
                </Box>

                <CustomTable
                  columns={columnsDocuments}
                  rows={productDocumentRows || []}
                  actionComponent={(row: any, rowIndex: number) => productDocActionComponent(row, rowIndex)}
                  disablePagination
                  showMenu
                  emptyText={editForm ? "No product documents found" : "Please upload the product documents in product edit"}
                  sx={productTableSx}
                />
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 1 }}>
                  {cancelButton}
                </Box>
              </Box>
            </Box>
          </form>
      </Box>

      {optionPopupShow.show &&
        <OptionsPopup
          open={optionPopupShow.show}
          onClose={() => setOptionPopupShow({ message: "", show: false })}
          variant={optionPopupShow.variant}
          message={<>{optionPopupShow.message}</>}
          buttons={optionPopupShow.buttons}
          title={optionPopupShow.title}
          obj={optionPopupShow.obj}
        />
      }
      {tierDeletePopup.show &&
        <OptionsPopup
          open={tierDeletePopup.show}
          onClose={() => setTierDeletePopup({ message: "", show: false })}
          variant={tierDeletePopup.variant}
          message={<>{tierDeletePopup.message}</>}
          buttons={tierDeletePopup.buttons}
          title={tierDeletePopup.title}
          obj={tierDeletePopup.obj}
        />
      }
      {datePickerPopupObj.open &&
        <DatePickerPopup
          open={datePickerPopupObj.open}
          title={datePickerPopupObj.title}
          label={datePickerPopupObj.label}
          submitDate={(date: string) => datePickerPopupObj.submitDate(date)}
          validationArray={datePickerPopupObj.validationArray}
          onClose={() => setDatePickerPopupObj({ label: "", title: "", open: false, validationArray: [], submitDate: (date: string) => { } })}
        />
      }
      {isProductDocumentPopupOpen && <ProductDocumentPopup open={isProductDocumentPopupOpen} onClose={() => setProductDocumentPopupOpen(false)} />}

       {showDocInactivePopup &&
                <DatePickerPopup
                open={showDocInactivePopup?.isShow}
                onClose={() => setShowDocInactivePopup({ isShow: false, productId: 0, manufacturerId: null, documentId: 0 }) }
                title={"Set Inactive Date"} label={""}
                submitDate={submitDocInactiveDate}
              />
       } 

      {showUpdateStatusPopup && (
        <UpdateProductDocumentStatusPopup
          open={showUpdateStatusPopup}
          statusData={statusData}
          originalStatusValue={originalStatusValue}
          onClose={() => {
            setUpdateStatusPopup(false);
            setIsEditing(false);
            setStatusData("");
          }}
        />
      )}

      <OrderProductModal
        open={orderOpen}
        onClose={() => setOrderOpen(false)}
        product={orderMarketProduct ? {
          productId: orderMarketProduct.productId,
          productName: orderMarketProduct.productName,
          manufacturerId: orderMarketProduct.manufacturerId,
          manufacturerName: orderMarketProduct.manufacturerName || "N/A",
          productCategory: orderMarketProduct.productCategory || undefined,
          extendedPrice: orderMarketProduct.extendedPrice ?? null,
          skuAllowablePrices: orderMarketProduct.skuAllowablePrices ?? null,
          hasSKUPrice: orderMarketProduct.hasSKUPrice,
        } : undefined}
      />

      {isOpenPrescription && rxMarketProduct && (
        <PrescriptionModalPopup
          product={rxMarketProduct}
          isOpen={isOpenPrescription}
          useExecutedAgreementPracticeRules
          onClose={(closedAfterSuccessfulSubmit) => {
            setIsOpenPrescription(false);
            if (closedAfterSuccessfulSubmit) {
              navigate("/prescription_list");
            }
          }}
          onSubmit={handleSubmitPrescription}
        />
      )}

      {showInfoPopup.show && (
        <InfoPopup
          open={showInfoPopup.show}
          content={showInfoPopup.message}
          onClose={() => setShowInfoPopup({ message: "", show: false, title: "" })}
          severity="error"
          title={showInfoPopup.title}
        />
      )}

      {showPRUWarning.show && (
        <WarningPopupNew
          open={showPRUWarning.show}
          onClose={() => setShowPRUWarning({ show: false, message: "" })}
          title={showPRUWarning.title}
          message={<>{showPRUWarning.message}</>}
          variant={showPRUWarning.variant}
          buttons={showPRUWarning.buttons}
        />
      )}

      {registrationModalOpen && (
        <CompletePracticeRegistrationModal
          open={registrationModalOpen}
          onClose={() => setRegistrationModalOpen(false)}
        />
      )}
    </>
  );
};

export default Product;
